/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления настройками Ntp-сервера
 */

/**
 * Сервис управления настройками Ntp-сервера
 */
export class NtpServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод редактирования настроек NTP
   */
  EditNtp = (req: Pick<EditNtpRequestDto, "updateMask"> & { data: NtpRequestDto & fm.RequireAtLeastOne<NtpRequestDto> }, init?: RequestInit): Promise<EditNtpResponseDto> => {
    return fm.request<Pick<EditNtpRequestDto, "updateMask"> & { data: NtpRequestDto & fm.RequireAtLeastOne<NtpRequestDto> }, EditNtpResponseDto>(`${this.host}/device/api/v1/ntp`, { ...init, method: "PATCH", body: JSON.stringify(req.data, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения настроек NTP
   */
  GetNtp = (req?: GetNtpRequestDto, init?: RequestInit): Promise<GetNtpResponseDto> => {
    return fm.request<GetNtpRequestDto, GetNtpResponseDto>(`${this.host}/device/api/v1/ntp${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник таймзон
 */
export enum NtpTimeZoneType {
  /**
   * Значение не указано
   */
  TIME_ZONE_TYPE_UNKNOWN = "TIME_ZONE_TYPE_UNKNOWN",
  /**
   * (GMT-11:00) Midway
   */
  GMTM1100_MIDWAY = "GMTM1100_MIDWAY",
  /**
   * (GMT-11:00) Niue
   */
  GMTM1100_NIUE = "GMTM1100_NIUE",
  /**
   * (GMT-10:00) Adak
   */
  GMTM1000_ADAK = "GMTM1000_ADAK",
  /**
   * (GMT-10:00) Honolulu
   */
  GMTM1000_HONOLULU = "GMTM1000_HONOLULU",
  /**
   * (GMT-10:00) Johnston
   */
  GMTM1000_JOHNSTON = "GMTM1000_JOHNSTON",
  /**
   * (GMT-10:00) Rarotonga
   */
  GMTM1000_RAROTONGA = "GMTM1000_RAROTONGA",
  /**
   * (GMT-10:00) Tahiti
   */
  GMTM1000_TAHITI = "GMTM1000_TAHITI",
  /**
   * (GMT-9:30) Marquesas
   */
  GMTM930_MARQUESAS = "GMTM930_MARQUESAS",
  /**
   * (GMT-9:00) Anchorage
   */
  GMTM900_ANCHORAGE = "GMTM900_ANCHORAGE",
  /**
   * (GMT-9:00) Juneau
   */
  GMTM900_JUNEAU = "GMTM900_JUNEAU",
  /**
   * (GMT-9:00) Metlakatla
   */
  GMTM900_METLAKATLA = "GMTM900_METLAKATLA",
  /**
   * (GMT-9:00) Nome
   */
  GMTM900_NOME = "GMTM900_NOME",
  /**
   * (GMT-9:00) Sitka
   */
  GMTM900_SITKA = "GMTM900_SITKA",
  /**
   * (GMT-9:00) Yakutat
   */
  GMTM900_YAKUTAT = "GMTM900_YAKUTAT",
  /**
   * (GMT-9:00) Gambier
   */
  GMTM900_GAMBIER = "GMTM900_GAMBIER",
  /**
   * (GMT-8:00) Los_Angeles
   */
  GMTM800_LOS_ANGELES = "GMTM800_LOS_ANGELES",
  /**
   * (GMT-8:00) Santa_Isabel
   */
  GMTM800_SANTA_ISABEL = "GMTM800_SANTA_ISABEL",
  /**
   * (GMT-8:00) Tijuana
   */
  GMTM800_TIJUANA = "GMTM800_TIJUANA",
  /**
   * (GMT-8:00) Vancouver
   */
  GMTM800_VANCOUVER = "GMTM800_VANCOUVER",
  /**
   * (GMT-8:00) Pitcairn
   */
  GMTM800_PITCAIRN = "GMTM800_PITCAIRN",
  /**
   * (GMT-7:00) Boise
   */
  GMTM700_BOISE = "GMTM700_BOISE",
  /**
   * (GMT-7:00) Cambridge_Bay
   */
  GMTM700_CAMBRIDGE_BAY = "GMTM700_CAMBRIDGE_BAY",
  /**
   * (GMT-7:00) Chihuahua
   */
  GMTM700_CHIHUAHUA = "GMTM700_CHIHUAHUA",
  /**
   * (GMT-7:00) Creston
   */
  GMTM700_CRESTON = "GMTM700_CRESTON",
  /**
   * (GMT-7:00) Dawson
   */
  GMTM700_DAWSON = "GMTM700_DAWSON",
  /**
   * (GMT-7:00) Dawson_Creek
   */
  GMTM700_DAWSON_CREEK = "GMTM700_DAWSON_CREEK",
  /**
   * (GMT-7:00) Denver
   */
  GMTM700_DENVER = "GMTM700_DENVER",
  /**
   * (GMT-7:00) Edmonton
   */
  GMTM700_EDMONTON = "GMTM700_EDMONTON",
  /**
   * (GMT-7:00) Fort_Nelson
   */
  GMTM700_FORT_NELSON = "GMTM700_FORT_NELSON",
  /**
   * (GMT-7:00) Hermosillo
   */
  GMTM700_HERMOSILLO = "GMTM700_HERMOSILLO",
  /**
   * (GMT-7:00) Inuvik
   */
  GMTM700_INUVIK = "GMTM700_INUVIK",
  /**
   * (GMT-7:00) Mazatlan
   */
  GMTM700_MAZATLAN = "GMTM700_MAZATLAN",
  /**
   * (GMT-7:00) Ojinaga
   */
  GMTM700_OJINAGA = "GMTM700_OJINAGA",
  /**
   * (GMT-7:00) Phoenix
   */
  GMTM700_PHOENIX = "GMTM700_PHOENIX",
  /**
   * (GMT-7:00) Shiprock
   */
  GMTM700_SHIPROCK = "GMTM700_SHIPROCK",
  /**
   * (GMT-7:00) Whitehorse
   */
  GMTM700_WHITEHORSE = "GMTM700_WHITEHORSE",
  /**
   * (GMT-7:00) Yellowknife<
   */
  GMTM700_YELLOWKNIFE = "GMTM700_YELLOWKNIFE",
  /**
   * (GMT-6:00) Bahia_Banderas
   */
  GMTM600_BAHIA_BANDERAS = "GMTM600_BAHIA_BANDERAS",
  /**
   * (GMT-6:00) Belize
   */
  GMTM600_BELIZE = "GMTM600_BELIZE",
  /**
   * (GMT-6:00) Chicago
   */
  GMTM600_CHICAGO = "GMTM600_CHICAGO",
  /**
   * (GMT-6:00) Costa_Rica
   */
  GMTM600_COSTA_RICA = "GMTM600_COSTA_RICA",
  /**
   * (GMT-6:00) El_Salvador
   */
  GMTM600_EL_SALVADOR = "GMTM600_EL_SALVADOR",
  /**
   * (GMT-6:00) Guatemala
   */
  GMTM600_GUATEMALA = "GMTM600_GUATEMALA",
  /**
   * (GMT-6:00) Knox
   */
  GMTM600_KNOX = "GMTM600_KNOX",
  /**
   * (GMT-6:00) Tell_City
   */
  GMTM600_TELL_CITY = "GMTM600_TELL_CITY",
  /**
   * (GMT-6:00) Managua
   */
  GMTM600_MANAGUA = "GMTM600_MANAGUA",
  /**
   * (GMT-6:00) Matamoros
   */
  GMTM600_MATAMOROS = "GMTM600_MATAMOROS",
  /**
   * (GMT-6:00) Menominee
   */
  GMTM600_MENOMINEE = "GMTM600_MENOMINEE",
  /**
   * (GMT-6:00) Merida
   */
  GMTM600_MERIDA = "GMTM600_MERIDA",
  /**
   * (GMT-6:00) Mexico_City
   */
  GMTM600_MEXICO_CITY = "GMTM600_MEXICO_CITY",
  /**
   * (GMT-6:00) Monterrey
   */
  GMTM600_MONTERREY = "GMTM600_MONTERREY",
  /**
   * (GMT-6:00) North_Dakota
   */
  GMTM600_NORTH_DAKOTA = "GMTM600_NORTH_DAKOTA",
  /**
   * (GMT-6:00) North_Dakota/Center
   */
  GMTM600_NORTH_DAKOTA_CENTER = "GMTM600_NORTH_DAKOTA_CENTER",
  /**
   * (GMT-6:00) North_Dakota/New_Salem
   */
  GMTM600_NORTH_DAKOTA_NEW_SALEM = "GMTM600_NORTH_DAKOTA_NEW_SALEM",
  /**
   * (GMT-6:00) Rainy_River
   */
  GMTM600_RAINY_RIVER = "GMTM600_RAINY_RIVER",
  /**
   * (GMT-6:00) Rankin_Inlet
   */
  GMTM600_RANKIN_INLET = "GMTM600_RANKIN_INLET",
  /**
   * (GMT-6:00) Regina
   */
  GMTM600_REGINA = "GMTM600_REGINA",
  /**
   * (GMT-6:00) Resolute
   */
  GMTM600_RESOLUTE = "GMTM600_RESOLUTE",
  /**
   * (GMT-6:00) Swift_Current
   */
  GMTM600_SWIFT_CURRENT = "GMTM600_SWIFT_CURRENT",
  /**
   * (GMT-6:00) Tegucigalpa
   */
  GMTM600_TEGUCIGALPA = "GMTM600_TEGUCIGALPA",
  /**
   * (GMT-6:00) Winnipeg
   */
  GMTM600_WINNIPEG = "GMTM600_WINNIPEG",
  /**
   * (GMT-6:00) Easter
   */
  GMTM600_EASTER = "GMTM600_EASTER",
  /**
   * (GMT-6:00) Galapagos
   */
  GMTM600_GALAPAGOS = "GMTM600_GALAPAGOS",
  /**
   * (GMT-5:00) Atikokan
   */
  GMTM500_ATIKOKAN = "GMTM500_ATIKOKAN",
  /**
   * (GMT-5:00) Bogota
   */
  GMTM500_BOGOTA = "GMTM500_BOGOTA",
  /**
   * (GMT-5:00) Cancun
   */
  GMTM500_CANCUN = "GMTM500_CANCUN",
  /**
   * (GMT-5:00) Cayman
   */
  GMTM500_CAYMAN = "GMTM500_CAYMAN",
  /**
   * (GMT-5:00) Detroit
   */
  GMTM500_DETROIT = "GMTM500_DETROIT",
  /**
   * (GMT-5:00) Eirunepe
   */
  GMTM500_EIRUNEPE = "GMTM500_EIRUNEPE",
  /**
   * (GMT-5:00) Grand_Turk
   */
  GMTM500_GRAND_TURK = "GMTM500_GRAND_TURK",
  /**
   * (GMT-5:00) Guayaquil
   */
  GMTM500_GUAYAQUIL = "GMTM500_GUAYAQUIL",
  /**
   * (GMT-5:00) Havana
   */
  GMTM500_HAVANA = "GMTM500_HAVANA",
  /**
   * (GMT-5:00) Indianapolis
   */
  GMTM500_INDIANAPOLIS = "GMTM500_INDIANAPOLIS",
  /**
   * (GMT-5:00) Marengo
   */
  GMTM500_MARENGO = "GMTM500_MARENGO",
  /**
   * (GMT-5:00) Petersburg
   */
  GMTM500_PETERSBURG = "GMTM500_PETERSBURG",
  /**
   * (GMT-5:00) Vevay
   */
  GMTM500_VEVAY = "GMTM500_VEVAY",
  /**
   * (GMT-5:00) Vincennes
   */
  GMTM500_VINCENNES = "GMTM500_VINCENNES",
  /**
   * (GMT-5:00) Winamac
   */
  GMTM500_WINAMAC = "GMTM500_WINAMAC",
  /**
   * (GMT-5:00) Iqaluit
   */
  GMTM500_IQALUIT = "GMTM500_IQALUIT",
  /**
   * (GMT-5:00) Jamaica
   */
  GMTM500_JAMAICA = "GMTM500_JAMAICA",
  /**
   * (GMT-5:00) Louisville
   */
  GMTM500_LOUISVILLE = "GMTM500_LOUISVILLE",
  /**
   * (GMT-5:00) Monticello
   */
  GMTM500_MONTICELLO = "GMTM500_MONTICELLO",
  /**
   * (GMT-5:00) Lima
   */
  GMTM500_LIMA = "GMTM500_LIMA",
  /**
   * (GMT-5:00) Montreal
   */
  GMTM500_MONTREAL = "GMTM500_MONTREAL",
  /**
   * (GMT-5:00) Nassau
   */
  GMTM500_NASSAU = "GMTM500_NASSAU",
  /**
   * (GMT-5:00) New_York
   */
  GMTM500_NEW_YORK = "GMTM500_NEW_YORK",
  /**
   * (GMT-5:00) Nipigon
   */
  GMTM500_NIPIGON = "GMTM500_NIPIGON",
  /**
   * (GMT-5:00) Panama
   */
  GMTM500_PANAMA = "GMTM500_PANAMA",
  /**
   * (GMT-5:00) Pangnirtung
   */
  GMTM500_PANGNIRTUNG = "GMTM500_PANGNIRTUNG",
  /**
   * (GMT-5:00) Port-au-Prince
   */
  GMTM500_POR_AU_PRINCE = "GMTM500_POR_AU_PRINCE",
  /**
   * (GMT-5:00) Rio_Branco
   */
  GMTM500_RIO_BRANCO = "GMTM500_RIO_BRANCO",
  /**
   * (GMT-5:00) Thunder_Bay
   */
  GMTM500_THUNDER_BAY = "GMTM500_THUNDER_BAY",
  /**
   * (GMT-5:00) Toronto
   */
  GMTM500_TORONTO = "GMTM500_TORONTO",
  /**
   * (GMT-4:00) Anguilla
   */
  GMTM400_ANGUILLA = "GMTM400_ANGUILLA",
  /**
   * (GMT-4:00) Antigua
   */
  GMTM400_ANTIGUA = "GMTM400_ANTIGUA",
  /**
   * (GMT-4:00) Aruba
   */
  GMTM400_ARUBA = "GMTM400_ARUBA",
  /**
   * (GMT-4:00) Asuncion
   */
  GMTM400_ASUNCION = "GMTM400_ASUNCION",
  /**
   * (GMT-4:00) Barbado
   */
  GMTM400_BARBADO = "GMTM400_BARBADO",
  /**
   * (GMT-4:00) Blanc-Sablon
   */
  GMTM400_BLANC_SABLON = "GMTM400_BLANC_SABLON",
  /**
   * (GMT-4:00) Boa_Vista
   */
  GMTM400_BOA_VISTA = "GMTM400_BOA_VISTA",
  /**
   * (GMT-4:00) Campo_Grande
   */
  GMTM400_CAMPO_GRANDE = "GMTM400_CAMPO_GRANDE",
  /**
   * (GMT-4:00) Caraca
   */
  GMTM400_CARACA = "GMTM400_CARACA",
  /**
   * (GMT-4:00) Cuiaba
   */
  GMTM400_CUIABA = "GMTM400_CUIABA",
  /**
   * (GMT-4:00) Curacao
   */
  GMTM400_CURACAO = "GMTM400_CURACAO",
  /**
   * (GMT-4:00) Dominica
   */
  GMTM400_DOMINICA = "GMTM400_DOMINICA",
  /**
   * (GMT-4:00) Glace_Bay
   */
  GMTM400_GLACE_BAY = "GMTM400_GLACE_BAY",
  /**
   * (GMT-4:00) Goose_Bay
   */
  GMTM400_GOOSE_BAY = "GMTM400_GOOSE_BAY",
  /**
   * (GMT-4:00) Grenada
   */
  GMTM400_GRENADA = "GMTM400_GRENADA",
  /**
   * (GMT-4:00) Guadeloupe
   */
  GMTM400_GUADELOUPE = "GMTM400_GUADELOUPE",
  /**
   * (GMT-4:00) Guyana
   */
  GMTM400_GUYANA = "GMTM400_GUYANA",
  /**
   * (GMT-4:00) Halifax
   */
  GMTM400_HALIFAX = "GMTM400_HALIFAX",
  /**
   * (GMT-4:00) Kralendijk
   */
  GMTM400_KRALENDIJK = "GMTM400_KRALENDIJK",
  /**
   * (GMT-4:00) La_Paz
   */
  GMTM400_LA_PAZ = "GMTM400_LA_PAZ",
  /**
   * (GMT-4:00) Lower_Prince
   */
  GMTM400_LOWER_PRINCE = "GMTM400_LOWER_PRINCE",
  /**
   * (GMT-4:00) Manau
   */
  GMTM400_MANAU = "GMTM400_MANAU",
  /**
   * (GMT-4:00) Marigot
   */
  GMTM400_MARIGOT = "GMTM400_MARIGOT",
  /**
   * (GMT-4:00) Martinique
   */
  GMTM400_MARTINIQUE = "GMTM400_MARTINIQUE",
  /**
   * (GMT-4:00) Moncton
   */
  GMTM400_MONCTON = "GMTM400_MONCTON",
  /**
   * (GMT-4:00) Montserrat
   */
  GMTM400_MONTSERRAT = "GMTM400_MONTSERRAT",
  /**
   * (GMT-4:00) Port_of_Spain
   */
  GMTM400_PORT_OF_SPAIN = "GMTM400_PORT_OF_SPAIN",
  /**
   * (GMT-4:00) Porto_Velho
   */
  GMTM400_PORTO_VELHO = "GMTM400_PORTO_VELHO",
  /**
   * (GMT-4:00) Puerto_Rico
   */
  GMTM400_PUERTO_RICO = "GMTM400_PUERTO_RICO",
  /**
   * (GMT-4:00) Santiago
   */
  GMTM400_SANTIAGO = "GMTM400_SANTIAGO",
  /**
   * (GMT-4:00) Santo_Domingo
   */
  GMTM400_SANTO_DOMINGO = "GMTM400_SANTO_DOMINGO",
  /**
   * (GMT-4:00) St_Barthelemy
   */
  GMTM400_ST_BARTHELEMY = "GMTM400_ST_BARTHELEMY",
  /**
   * (GMT-4:00) St_Kitt
   */
  GMTM400_ST_KITT = "GMTM400_ST_KITT",
  /**
   * (GMT-4:00) St_Lucia
   */
  GMTM400_ST_LUCIA = "GMTM400_ST_LUCIA",
  /**
   * (GMT-4:00) St_Thoma
   */
  GMTM400_ST_THOMA = "GMTM400_ST_THOMA",
  /**
   * (GMT-4:00) St_Vincent
   */
  GMTM400_ST_VINCENT = "GMTM400_ST_VINCENT",
  /**
   * (GMT-4:00) Thule
   */
  GMTM400_THULE = "GMTM400_THULE",
  /**
   * (GMT-4:00) Tortola
   */
  GMTM400_TORTOLA = "GMTM400_TORTOLA",
  /**
   * (GMT-4:00) Bermuda
   */
  GMTM400_BERMUDA = "GMTM400_BERMUDA",
  /**
   * (GMT-3:30) St_John
   */
  GMTM330_ST_JOHN = "GMTM330_ST_JOHN",
  /**
   * (GMT-3:00) Araguaina
   */
  GMTM300_ARAGUAINA = "GMTM300_ARAGUAINA",
  /**
   * (GMT-3:00) Buenos_Aire
   */
  GMTM300_BUENOS_AIRE = "GMTM300_BUENOS_AIRE",
  /**
   * (GMT-3:00) Catamarca
   */
  GMTM300_CATAMARCA = "GMTM300_CATAMARCA",
  /**
   * (GMT-3:00) Cordoba
   */
  GMTM300_CORDOBA = "GMTM300_CORDOBA",
  /**
   * (GMT-3:00) Jujuy
   */
  GMTM300_JUJUY = "GMTM300_JUJUY",
  /**
   * (GMT-3:00) La_Rioja
   */
  GMTM300_LA_RIOJA = "GMTM300_LA_RIOJA",
  /**
   * (GMT-3:00) Mendoza
   */
  GMTM300_MENDOZA = "GMTM300_MENDOZA",
  /**
   * (GMT-3:00) Rio_Gallego
   */
  GMTM300_RIO_GALLEGO = "GMTM300_RIO_GALLEGO",
  /**
   * (GMT-3:00) Salta
   */
  GMTM300_SALTA = "GMTM300_SALTA",
  /**
   * (GMT-3:00) San_Juan
   */
  GMTM300_SAN_JUAN = "GMTM300_SAN_JUAN",
  /**
   * (GMT-3:00) San_Lui
   */
  GMTM300_SAN_LUI = "GMTM300_SAN_LUI",
  /**
   * (GMT-3:00) Tucuman
   */
  GMTM300_TUCUMAN = "GMTM300_TUCUMAN",
  /**
   * (GMT-3:00) Ushuaia
   */
  GMTM300_USHUAIA = "GMTM300_USHUAIA",
  /**
   * (GMT-3:00) Bahia
   */
  GMTM300_BAHIA = "GMTM300_BAHIA",
  /**
   * (GMT-3:00) Belem
   */
  GMTM300_BELEM = "GMTM300_BELEM",
  /**
   * (GMT-3:00) Cayenne
   */
  GMTM300_CAYENNE = "GMTM300_CAYENNE",
  /**
   * (GMT-3:00) Fortaleza
   */
  GMTM300_FORTALEZA = "GMTM300_FORTALEZA",
  /**
   * (GMT-3:00) Godthab
   */
  GMTM300_GODTHAB = "GMTM300_GODTHAB",
  /**
   * (GMT-3:00) Maceio
   */
  GMTM300_MACEIO = "GMTM300_MACEIO",
  /**
   * (GMT-3:00) Miquelon
   */
  GMTM300_MIQUELON = "GMTM300_MIQUELON",
  /**
   * (GMT-3:00) Montevideo
   */
  GMTM300_MONTEVIDEO = "GMTM300_MONTEVIDEO",
  /**
   * (GMT-3:00) Nuuk
   */
  GMTM300_NUUK = "GMTM300_NUUK",
  /**
   * (GMT-3:00) Paramaribo
   */
  GMTM300_PARAMARIBO = "GMTM300_PARAMARIBO",
  /**
   * (GMT-3:00) Punta_Arena
   */
  GMTM300_PUNTA_ARENA = "GMTM300_PUNTA_ARENA",
  /**
   * (GMT-3:00) Recife
   */
  GMTM300_RECIFE = "GMTM300_RECIFE",
  /**
   * (GMT-3:00) Santarem
   */
  GMTM300_SANTAREM = "GMTM300_SANTAREM",
  /**
   * (GMT-3:00) Sao_Paulo
   */
  GMTM300_SAO_PAULO = "GMTM300_SAO_PAULO",
  /**
   * (GMT-3:00) Palmer
   */
  GMTM300_PALMER = "GMTM300_PALMER",
  /**
   * (GMT-3:00) Rothera
   */
  GMTM300_ROTHERA = "GMTM300_ROTHERA",
  /**
   * (GMT-3:00) Stanley
   */
  GMTM300_STANLEY = "GMTM300_STANLEY",
  /**
   * (GMT-2:00) Noronha
   */
  GMTM200_NORONHA = "GMTM200_NORONHA",
  /**
   * (GMT-2:00) South_Georgia
   */
  GMTM200_SOUTH_GEORGIA = "GMTM200_SOUTH_GEORGIA",
  /**
   * (GMT-1:00) Scoresbysund
   */
  GMTM100_SCORESBYSUND = "GMTM100_SCORESBYSUND",
  /**
   * (GMT-1:00) Azore
   */
  GMTM100_AZORE = "GMTM100_AZORE",
  /**
   * (GMT-1:00) Cape_Verde
   */
  GMTM100_CAPE_VERDE = "GMTM100_CAPE_VERDE",
  /**
   * (GMT+0:00) Abidjan
   */
  GMTP000_ABIDJAN = "GMTP000_ABIDJAN",
  /**
   * (GMT+0:00) Accra
   */
  GMTP000_ACCRA = "GMTP000_ACCRA",
  /**
   * (GMT+0:00) Bamako
   */
  GMTP000_BAMAKO = "GMTP000_BAMAKO",
  /**
   * (GMT+0:00) Banjul
   */
  GMTP000_BANJUL = "GMTP000_BANJUL",
  /**
   * (GMT+0:00) Bissau
   */
  GMTP000_BISSAU = "GMTP000_BISSAU",
  /**
   * (GMT+0:00) Conakry
   */
  GMTP000_CONAKRY = "GMTP000_CONAKRY",
  /**
   * (GMT+0:00) Dakar
   */
  GMTP000_DAKAR = "GMTP000_DAKAR",
  /**
   * (GMT+0:00) Freetown
   */
  GMTP000_FREETOWN = "GMTP000_FREETOWN",
  /**
   * (GMT+0:00) Lome
   */
  GMTP000_LOME = "GMTP000_LOME",
  /**
   * (GMT+0:00) Monrovia
   */
  GMTP000_MONROVIA = "GMTP000_MONROVIA",
  /**
   * (GMT+0:00) Nouakchott
   */
  GMTP000_NOUAKCHOTT = "GMTP000_NOUAKCHOTT",
  /**
   * (GMT+0:00) Ouagadougou
   */
  GMTP000_OUAGADOUGOU = "GMTP000_OUAGADOUGOU",
  /**
   * (GMT+0:00) Sao_Tome
   */
  GMTP000_SAO_TOME = "GMTP000_SAO_TOME",
  /**
   * (GMT+0:00) Danmarkshavn
   */
  GMTP000_DANMARKSHAVN = "GMTP000_DANMARKSHAVN",
  /**
   * (GMT+0:00) Troll
   */
  GMTP000_TROLL = "GMTP000_TROLL",
  /**
   * (GMT+0:00) Canary
   */
  GMTP000_CANARY = "GMTP000_CANARY",
  /**
   * (GMT+0:00) Faroe
   */
  GMTP000_FAROE = "GMTP000_FAROE",
  /**
   * (GMT+0:00) Madeira
   */
  GMTP000_MADEIRA = "GMTP000_MADEIRA",
  /**
   * (GMT+0:00) Reykjavik
   */
  GMTP000_REYKJAVIK = "GMTP000_REYKJAVIK",
  /**
   * (GMT+0:00) St_Helena
   */
  GMTP000_ST_HELENA = "GMTP000_ST_HELENA",
  /**
   * (GMT+0:00) Guernsey
   */
  GMTP000_GUERNSEY = "GMTP000_GUERNSEY",
  /**
   * (GMT+0:00) Isle_of_Man
   */
  GMTP000_ISLE_OF_MAN = "GMTP000_ISLE_OF_MAN",
  /**
   * (GMT+0:00) Jersey
   */
  GMTP000_JERSEY = "GMTP000_JERSEY",
  /**
   * (GMT+0:00) Lisbon
   */
  GMTP000_LISBON = "GMTP000_LISBON",
  /**
   * (GMT+0:00) London
   */
  GMTP000_LONDON = "GMTP000_LONDON",
  /**
   * (GMT+0:00) GMT
   */
  GMTP000_GMT = "GMTP000_GMT",
  /**
   * (GMT+1:00) Algier
   */
  GMTP100_ALGIER = "GMTP100_ALGIER",
  /**
   * (GMT+1:00) Bangui
   */
  GMTP100_BANGUI = "GMTP100_BANGUI",
  /**
   * (GMT+1:00) Brazzaville
   */
  GMTP100_BRAZZAVILLE = "GMTP100_BRAZZAVILLE",
  /**
   * (GMT+1:00) Casablanca
   */
  GMTP100_CASABLANCA = "GMTP100_CASABLANCA",
  /**
   * (GMT+1:00) Ceuta
   */
  GMTP100_CEUTA = "GMTP100_CEUTA",
  /**
   * (GMT+1:00) Douala
   */
  GMTP100_DOUALA = "GMTP100_DOUALA",
  /**
   * (GMT+1:00) El_Aaiun
   */
  GMTP100_EL_AAIUN = "GMTP100_EL_AAIUN",
  /**
   * (GMT+1:00) Kinshasa
   */
  GMTP100_KINSHASA = "GMTP100_KINSHASA",
  /**
   * (GMT+1:00) Lago
   */
  GMTP100_LAGO = "GMTP100_LAGO",
  /**
   * (GMT+1:00) Libreville
   */
  GMTP100_LIBREVILLE = "GMTP100_LIBREVILLE",
  /**
   * (GMT+1:00) Luanda
   */
  GMTP100_LUANDA = "GMTP100_LUANDA",
  /**
   * (GMT+1:00) Malabo
   */
  GMTP100_MALABO = "GMTP100_MALABO",
  /**
   * (GMT+1:00) Ndjamena
   */
  GMTP100_NDJAMENA = "GMTP100_NDJAMENA",
  /**
   * (GMT+1:00) Niamey
   */
  GMTP100_NIAMEY = "GMTP100_NIAMEY",
  /**
   * (GMT+1:00) Porto-Novo
   */
  GMTP100_PORTO_NOVO = "GMTP100_PORTO_NOVO",
  /**
   * (GMT+1:00) Tuni
   */
  GMTP100_TUNI = "GMTP100_TUNI",
  /**
   * (GMT+1:00) Longyearbyen
   */
  GMTP100_LONGYEARBYEN = "GMTP100_LONGYEARBYEN",
  /**
   * (GMT+1:00) Amsterdam
   */
  GMTP100_AMSTERDAM = "GMTP100_AMSTERDAM",
  /**
   * (GMT+1:00) Andorra
   */
  GMTP100_ANDORRA = "GMTP100_ANDORRA",
  /**
   * (GMT+1:00) Belgrade
   */
  GMTP100_BELGRADE = "GMTP100_BELGRADE",
  /**
   * (GMT+1:00) Berlin
   */
  GMTP100_BERLIN = "GMTP100_BERLIN",
  /**
   * (GMT+1:00) Bratislava
   */
  GMTP100_BRATISLAVA = "GMTP100_BRATISLAVA",
  /**
   * (GMT+1:00) Brussel
   */
  GMTP100_BRUSSEL = "GMTP100_BRUSSEL",
  /**
   * (GMT+1:00) Budapest
   */
  GMTP100_BUDAPEST = "GMTP100_BUDAPEST",
  /**
   * (GMT+1:00) Busingen
   */
  GMTP100_BUSINGEN = "GMTP100_BUSINGEN",
  /**
   * (GMT+1:00) Copenhagen
   */
  GMTP100_COPENHAGEN = "GMTP100_COPENHAGEN",
  /**
   * (GMT+1:00) Dublin
   */
  GMTP100_DUBLIN = "GMTP100_DUBLIN",
  /**
   * (GMT+1:00) Gibraltar
   */
  GMTP100_GIBRALTAR = "GMTP100_GIBRALTAR",
  /**
   * (GMT+1:00) Ljubljana
   */
  GMTP100_LJUBLJANA = "GMTP100_LJUBLJANA",
  /**
   * (GMT+1:00) Luxembourg
   */
  GMTP100_LUXEMBOURG = "GMTP100_LUXEMBOURG",
  /**
   * (GMT+1:00) Madrid
   */
  GMTP100_MADRID = "GMTP100_MADRID",
  /**
   * (GMT+1:00) Malta
   */
  GMTP100_MALTA = "GMTP100_MALTA",
  /**
   * (GMT+1:00) Monaco
   */
  GMTP100_MONACO = "GMTP100_MONACO",
  /**
   * (GMT+1:00) Oslo
   */
  GMTP100_OSLO = "GMTP100_OSLO",
  /**
   * (GMT+1:00) Pari
   */
  GMTP100_PARI = "GMTP100_PARI",
  /**
   * (GMT+1:00) Podgorica
   */
  GMTP100_PODGORICA = "GMTP100_PODGORICA",
  /**
   * (GMT+1:00) Prague
   */
  GMTP100_PRAGUE = "GMTP100_PRAGUE",
  /**
   * (GMT+1:00) Rome
   */
  GMTP100_ROME = "GMTP100_ROME",
  /**
   * (GMT+1:00) San_Marino
   */
  GMTP100_SAN_MARINO = "GMTP100_SAN_MARINO",
  /**
   * (GMT+1:00) Sarajevo
   */
  GMTP100_SARAJEVO = "GMTP100_SARAJEVO",
  /**
   * (GMT+1:00) Skopje
   */
  GMTP100_SKOPJE = "GMTP100_SKOPJE",
  /**
   * (GMT+1:00) Stockholm
   */
  GMTP100_STOCKHOLM = "GMTP100_STOCKHOLM",
  /**
   * (GMT+1:00) Tirane
   */
  GMTP100_TIRANE = "GMTP100_TIRANE",
  /**
   * (GMT+1:00) Vaduz
   */
  GMTP100_VADUZ = "GMTP100_VADUZ",
  /**
   * (GMT+1:00) Vatican
   */
  GMTP100_VATICAN = "GMTP100_VATICAN",
  /**
   * (GMT+1:00) Vienna
   */
  GMTP100_VIENNA = "GMTP100_VIENNA",
  /**
   * (GMT+1:00) Warsaw
   */
  GMTP100_WARSAW = "GMTP100_WARSAW",
  /**
   * (GMT+1:00) Zagreb
   */
  GMTP100_ZAGREB = "GMTP100_ZAGREB",
  /**
   * (GMT+1:00) Zurich
   */
  GMTP100_ZURICH = "GMTP100_ZURICH",
  /**
   * (GMT+2:00) Blantyre
   */
  GMTP200_BLANTYRE = "GMTP200_BLANTYRE",
  /**
   * (GMT+2:00) Bujumbura
   */
  GMTP200_BUJUMBURA = "GMTP200_BUJUMBURA",
  /**
   * (GMT+2:00) Cairo
   */
  GMTP200_CAIRO = "GMTP200_CAIRO",
  /**
   * (GMT+2:00) Gaborone
   */
  GMTP200_GABORONE = "GMTP200_GABORONE",
  /**
   * (GMT+2:00) Harare
   */
  GMTP200_HARARE = "GMTP200_HARARE",
  /**
   * (GMT+2:00) Johannesburg
   */
  GMTP200_JOHANNESBURG = "GMTP200_JOHANNESBURG",
  /**
   * (GMT+2:00) Khartoum
   */
  GMTP200_KHARTOUM = "GMTP200_KHARTOUM",
  /**
   * (GMT+2:00) Kigali
   */
  GMTP200_KIGALI = "GMTP200_KIGALI",
  /**
   * (GMT+2:00) Lubumbashi
   */
  GMTP200_LUBUMBASHI = "GMTP200_LUBUMBASHI",
  /**
   * (GMT+2:00) Lusaka
   */
  GMTP200_LUSAKA = "GMTP200_LUSAKA",
  /**
   * (GMT+2:00) Maputo
   */
  GMTP200_MAPUTO = "GMTP200_MAPUTO",
  /**
   * (GMT+2:00) Maseru
   */
  GMTP200_MASERU = "GMTP200_MASERU",
  /**
   * (GMT+2:00) Mbabane
   */
  GMTP200_MBABANE = "GMTP200_MBABANE",
  /**
   * (GMT+2:00) Tripoli
   */
  GMTP200_TRIPOLI = "GMTP200_TRIPOLI",
  /**
   * (GMT+2:00) Windhoek
   */
  GMTP200_WINDHOEK = "GMTP200_WINDHOEK",
  /**
   * (GMT+2:00) Amman
   */
  GMTP200_AMMAN = "GMTP200_AMMAN",
  /**
   * (GMT+2:00) Beirut
   */
  GMTP200_BEIRUT = "GMTP200_BEIRUT",
  /**
   * (GMT+2:00) Damascu
   */
  GMTP200_DAMASCU = "GMTP200_DAMASCU",
  /**
   * (GMT+2:00) Famagusta
   */
  GMTP200_FAMAGUSTA = "GMTP200_FAMAGUSTA",
  /**
   * (GMT+2:00) Gaza
   */
  GMTP200_GAZA = "GMTP200_GAZA",
  /**
   * (GMT+2:00) Hebron
   */
  GMTP200_HEBRON = "GMTP200_HEBRON",
  /**
   * (GMT+2:00) Jerusalem
   */
  GMTP200_JERUSALEM = "GMTP200_JERUSALEM",
  /**
   * (GMT+2:00) Athen
   */
  GMTP200_ATHEN = "GMTP200_ATHEN",
  /**
   * (GMT+2:00) Bucharest
   */
  GMTP200_BUCHAREST = "GMTP200_BUCHAREST",
  /**
   * (GMT+2:00) Chisinau
   */
  GMTP200_CHISINAU = "GMTP200_CHISINAU",
  /**
   * (GMT+2:00) Helsinki
   */
  GMTP200_HELSINKI = "GMTP200_HELSINKI",
  /**
   * (GMT+2:00) Kaliningrad
   */
  GMTP200_KALININGRAD = "GMTP200_KALININGRAD",
  /**
   * (GMT+2:00) Kiev
   */
  GMTP200_KIEV = "GMTP200_KIEV",
  /**
   * (GMT+2:00) Mariehamn
   */
  GMTP200_MARIEHAMN = "GMTP200_MARIEHAMN",
  /**
   * (GMT+2:00) Nicosia
   */
  GMTP200_NICOSIA = "GMTP200_NICOSIA",
  /**
   * (GMT+2:00) Riga
   */
  GMTP200_RIGA = "GMTP200_RIGA",
  /**
   * (GMT+2:00) Sofia
   */
  GMTP200_SOFIA = "GMTP200_SOFIA",
  /**
   * (GMT+2:00) Tallinn
   */
  GMTP200_TALLINN = "GMTP200_TALLINN",
  /**
   * (GMT+2:00) Uzhgorod
   */
  GMTP200_UZHGOROD = "GMTP200_UZHGOROD",
  /**
   * (GMT+2:00) Vilniu
   */
  GMTP200_VILNIU = "GMTP200_VILNIU",
  /**
   * (GMT+2:00) Zaporozhye
   */
  GMTP200_ZAPOROZHYE = "GMTP200_ZAPOROZHYE",
  /**
   * (GMT+3:00) Addis_Ababa
   */
  GMTP300_ADDIS_ABABA = "GMTP300_ADDIS_ABABA",
  /**
   * (GMT+3:00) Asmara
   */
  GMTP300_ASMARA = "GMTP300_ASMARA",
  /**
   * (GMT+3:00) Dar_es_Salaam
   */
  GMTP300_DAR_ES_SALAAM = "GMTP300_DAR_ES_SALAAM",
  /**
   * (GMT+3:00) Djibouti
   */
  GMTP300_DJIBOUTI = "GMTP300_DJIBOUTI",
  /**
   * (GMT+3:00) Juba
   */
  GMTP300_JUBA = "GMTP300_JUBA",
  /**
   * (GMT+3:00) Kampala
   */
  GMTP300_KAMPALA = "GMTP300_KAMPALA",
  /**
   * (GMT+3:00) Mogadishu
   */
  GMTP300_MOGADISHU = "GMTP300_MOGADISHU",
  /**
   * (GMT+3:00) Nairobi
   */
  GMTP300_NAIROBI = "GMTP300_NAIROBI",
  /**
   * (GMT+3:00) Syowa
   */
  GMTP300_SYOWA = "GMTP300_SYOWA",
  /**
   * (GMT+3:00) Aden
   */
  GMTP300_ADEN = "GMTP300_ADEN",
  /**
   * (GMT+3:00) Baghdad
   */
  GMTP300_BAGHDAD = "GMTP300_BAGHDAD",
  /**
   * (GMT+3:00) Bahrain
   */
  GMTP300_BAHRAIN = "GMTP300_BAHRAIN",
  /**
   * (GMT+3:00) Kuwait
   */
  GMTP300_KUWAIT = "GMTP300_KUWAIT",
  /**
   * (GMT+3:00) Qatar
   */
  GMTP300_QATAR = "GMTP300_QATAR",
  /**
   * (GMT+3:00) Riyadh
   */
  GMTP300_RIYADH = "GMTP300_RIYADH",
  /**
   * (GMT+3:00) Istanbul
   */
  GMTP300_ISTANBUL = "GMTP300_ISTANBUL",
  /**
   * (GMT+3:00) Kirov
   */
  GMTP300_KIROV = "GMTP300_KIROV",
  /**
   * (GMT+3:00) Minsk
   */
  GMTP300_MINSK = "GMTP300_MINSK",
  /**
   * (GMT+3:00) Moscow
   */
  GMTP300_MOSCOW = "GMTP300_MOSCOW",
  /**
   * (GMT+3:00) Simferopol
   */
  GMTP300_SIMFEROPOL = "GMTP300_SIMFEROPOL",
  /**
   * (GMT+3:00) Antananarivo
   */
  GMTP300_ANTANANARIVO = "GMTP300_ANTANANARIVO",
  /**
   * (GMT+3:00) Comoro
   */
  GMTP300_COMORO = "GMTP300_COMORO",
  /**
   * (GMT+3:00) Mayotte
   */
  GMTP300_MAYOTTE = "GMTP300_MAYOTTE",
  /**
   * (GMT+3:30) Tehran
   */
  GMTP330_TEHRAN = "GMTP330_TEHRAN",
  /**
   * (GMT+4:00) Baku
   */
  GMTP400_BAKU = "GMTP400_BAKU",
  /**
   * (GMT+4:00) Dubai
   */
  GMTP400_DUBAI = "GMTP400_DUBAI",
  /**
   * (GMT+4:00) Muscat
   */
  GMTP400_MUSCAT = "GMTP400_MUSCAT",
  /**
   * (GMT+4:00) Tbilisi
   */
  GMTP400_TBILISI = "GMTP400_TBILISI",
  /**
   * (GMT+4:00) Yerevan
   */
  GMTP400_YEREVAN = "GMTP400_YEREVAN",
  /**
   * (GMT+4:00) Astrakhan
   */
  GMTP400_ASTRAKHAN = "GMTP400_ASTRAKHAN",
  /**
   * (GMT+4:00) Samara
   */
  GMTP400_SAMARA = "GMTP400_SAMARA",
  /**
   * (GMT+4:00) Saratov
   */
  GMTP400_SARATOV = "GMTP400_SARATOV",
  /**
   * (GMT+4:00) Ulyanovsk
   */
  GMTP400_ULYANOVSK = "GMTP400_ULYANOVSK",
  /**
   * (GMT+4:00) Volgograd
   */
  GMTP400_VOLGOGRAD = "GMTP400_VOLGOGRAD",
  /**
   * (GMT+4:00) Mahe
   */
  GMTP400_MAHE = "GMTP400_MAHE",
  /**
   * (GMT+4:00) Mauritiu
   */
  GMTP400_MAURITIU = "GMTP400_MAURITIU",
  /**
   * (GMT+4:00) Reunion
   */
  GMTP400_REUNION = "GMTP400_REUNION",
  /**
   * (GMT+4:30) Kabul
   */
  GMTP430_KABUL = "GMTP430_KABUL",
  /**
   * (GMT+5:00) Mawson
   */
  GMTP500_MAWSON = "GMTP500_MAWSON",
  /**
   * (GMT+5:00) Aqtau
   */
  GMTP500_AQTAU = "GMTP500_AQTAU",
  /**
   * (GMT+5:00) Aqtobe
   */
  GMTP500_AQTOBE = "GMTP500_AQTOBE",
  /**
   * (GMT+5:00) Ashgabat
   */
  GMTP500_ASHGABAT = "GMTP500_ASHGABAT",
  /**
   * (GMT+5:00) Atyrau
   */
  GMTP500_ATYRAU = "GMTP500_ATYRAU",
  /**
   * (GMT+5:00) Dushanbe
   */
  GMTP500_DUSHANBE = "GMTP500_DUSHANBE",
  /**
   * (GMT+5:00) Karachi
   */
  GMTP500_KARACHI = "GMTP500_KARACHI",
  /**
   * (GMT+5:00) Oral
   */
  GMTP500_ORAL = "GMTP500_ORAL",
  /**
   * (GMT+5:00) Qyzylorda
   */
  GMTP500_QYZYLORDA = "GMTP500_QYZYLORDA",
  /**
   * (GMT+5:00) Samarkand
   */
  GMTP500_SAMARKAND = "GMTP500_SAMARKAND",
  /**
   * (GMT+5:00) Tashkent
   */
  GMTP500_TASHKENT = "GMTP500_TASHKENT",
  /**
   * (GMT+5:00) Yekaterinburg
   */
  GMTP500_YEKATERINBURG = "GMTP500_YEKATERINBURG",
  /**
   * (GMT+5:00) Kerguelen
   */
  GMTP500_KERGUELEN = "GMTP500_KERGUELEN",
  /**
   * (GMT+5:00) Maldive
   */
  GMTP500_MALDIVE = "GMTP500_MALDIVE",
  /**
   * (GMT+5:30) Calcutta
   */
  GMTP530_CALCUTTA = "GMTP530_CALCUTTA",
  /**
   * (GMT+5:30) Colombo
   */
  GMTP530_COLOMBO = "GMTP530_COLOMBO",
  /**
   * (GMT+5:30) Kolkata
   */
  GMTP530_KOLKATA = "GMTP530_KOLKATA",
  /**
   * (GMT+5:45) Kathmandu
   */
  GMTP545_KATHMANDU = "GMTP545_KATHMANDU",
  /**
   * (GMT+5:45) Katmandu
   */
  GMTP545_KATMANDU = "GMTP545_KATMANDU",
  /**
   * (GMT+6:00) Vostok
   */
  GMTP600_VOSTOK = "GMTP600_VOSTOK",
  /**
   * (GMT+6:00) Almaty
   */
  GMTP600_ALMATY = "GMTP600_ALMATY",
  /**
   * (GMT+6:00) Bishkek
   */
  GMTP600_BISHKEK = "GMTP600_BISHKEK",
  /**
   * (GMT+6:00) Dhaka
   */
  GMTP600_DHAKA = "GMTP600_DHAKA",
  /**
   * (GMT+6:00) Kashgar
   */
  GMTP600_KASHGAR = "GMTP600_KASHGAR",
  /**
   * (GMT+6:00) Omsk
   */
  GMTP600_OMSK = "GMTP600_OMSK",
  /**
   * (GMT+6:00) Qostanay
   */
  GMTP600_QOSTANAY = "GMTP600_QOSTANAY",
  /**
   * (GMT+6:00) Thimphu
   */
  GMTP600_THIMPHU = "GMTP600_THIMPHU",
  /**
   * (GMT+6:00) Urumqi
   */
  GMTP600_URUMQI = "GMTP600_URUMQI",
  /**
   * (GMT+6:00) Chago
   */
  GMTP600_CHAGO = "GMTP600_CHAGO",
  /**
   * (GMT+6:30) Rangoon
   */
  GMTP630_RANGOON = "GMTP630_RANGOON",
  /**
   * (GMT+6:30) Yangon
   */
  GMTP630_YANGON = "GMTP630_YANGON",
  /**
   * (GMT+6:30) Coco
   */
  GMTP630_COCO = "GMTP630_COCO",
  /**
   * (GMT+7:00) Davi
   */
  GMTP700_DAVI = "GMTP700_DAVI",
  /**
   * (GMT+7:00) Bangkok
   */
  GMTP700_BANGKOK = "GMTP700_BANGKOK",
  /**
   * (GMT+7:00) Barnaul
   */
  GMTP700_BARNAUL = "GMTP700_BARNAUL",
  /**
   * (GMT+7:00) Ho_Chi_Minh
   */
  GMTP700_HO_CHI_MINH = "GMTP700_HO_CHI_MINH",
  /**
   * (GMT+7:00) Hovd
   */
  GMTP700_HOVD = "GMTP700_HOVD",
  /**
   * (GMT+7:00) Jakarta
   */
  GMTP700_JAKARTA = "GMTP700_JAKARTA",
  /**
   * (GMT+7:00) Krasnoyarsk
   */
  GMTP700_KRASNOYARSK = "GMTP700_KRASNOYARSK",
  /**
   * (GMT+7:00) Novokuznetsk
   */
  GMTP700_NOVOKUZNETSK = "GMTP700_NOVOKUZNETSK",
  /**
   * (GMT+7:00) Novosibirsk
   */
  GMTP700_NOVOSIBIRSK = "GMTP700_NOVOSIBIRSK",
  /**
   * (GMT+7:00) Phnom_Penh
   */
  GMTP700_PHNOM_PENH = "GMTP700_PHNOM_PENH",
  /**
   * (GMT+7:00) Pontianak
   */
  GMTP700_PONTIANAK = "GMTP700_PONTIANAK",
  /**
   * (GMT+7:00) Tomsk
   */
  GMTP700_TOMSK = "GMTP700_TOMSK",
  /**
   * (GMT+7:00) Vientiane
   */
  GMTP700_VIENTIANE = "GMTP700_VIENTIANE",
  /**
   * (GMT+7:00) Christma
   */
  GMTP700_CHRISTMA = "GMTP700_CHRISTMA",
  /**
   * (GMT+8:00) Casey
   */
  GMTP800_CASEY = "GMTP800_CASEY",
  /**
   * (GMT+8:00) Brunei
   */
  GMTP800_BRUNEI = "GMTP800_BRUNEI",
  /**
   * (GMT+8:00) Choibalsan
   */
  GMTP800_CHOIBALSAN = "GMTP800_CHOIBALSAN",
  /**
   * (GMT+8:00) Chongqing
   */
  GMTP800_CHONGQING = "GMTP800_CHONGQING",
  /**
   * (GMT+8:00) Harbin
   */
  GMTP800_HARBIN = "GMTP800_HARBIN",
  /**
   * (GMT+8:00) Hong_Kong
   */
  GMTP800_HONG_KONG = "GMTP800_HONG_KONG",
  /**
   * (GMT+8:00) Irkutsk
   */
  GMTP800_IRKUTSK = "GMTP800_IRKUTSK",
  /**
   * (GMT+8:00) Kuala_Lumpur
   */
  GMTP800_KUALA_LUMPUR = "GMTP800_KUALA_LUMPUR",
  /**
   * (GMT+8:00) Kuching
   */
  GMTP800_KUCHING = "GMTP800_KUCHING",
  /**
   * (GMT+8:00) Macau
   */
  GMTP800_MACAU = "GMTP800_MACAU",
  /**
   * (GMT+8:00) Makassar
   */
  GMTP800_MAKASSAR = "GMTP800_MAKASSAR",
  /**
   * (GMT+8:00) Manila
   */
  GMTP800_MANILA = "GMTP800_MANILA",
  /**
   * (GMT+8:00) Shanghai
   */
  GMTP800_SHANGHAI = "GMTP800_SHANGHAI",
  /**
   * (GMT+8:00) Singapore
   */
  GMTP800_SINGAPORE = "GMTP800_SINGAPORE",
  /**
   * (GMT+8:00) Taipei
   */
  GMTP800_TAIPEI = "GMTP800_TAIPEI",
  /**
   * (GMT+8:00) Ulaanbaatar
   */
  GMTP800_ULAANBAATAR = "GMTP800_ULAANBAATAR",
  /**
   * (GMT+8:00) Perth
   */
  GMTP800_PERTH = "GMTP800_PERTH",
  /**
   * (GMT+8:45) Eucla
   */
  GMTP845_EUCLA = "GMTP845_EUCLA",
  /**
   * (GMT+9:00) Chita
   */
  GMTP900_CHITA = "GMTP900_CHITA",
  /**
   * (GMT+9:00) Dili
   */
  GMTP900_DILI = "GMTP900_DILI",
  /**
   * (GMT+9:00) Jayapura
   */
  GMTP900_JAYAPURA = "GMTP900_JAYAPURA",
  /**
   * (GMT+9:00) Khandyga
   */
  GMTP900_KHANDYGA = "GMTP900_KHANDYGA",
  /**
   * (GMT+9:00) Pyongyang
   */
  GMTP900_PYONGYANG = "GMTP900_PYONGYANG",
  /**
   * (GMT+9:00) Seoul
   */
  GMTP900_SEOUL = "GMTP900_SEOUL",
  /**
   * (GMT+9:00) Tokyo
   */
  GMTP900_TOKYO = "GMTP900_TOKYO",
  /**
   * (GMT+9:00) Yakutsk
   */
  GMTP900_YAKUTSK = "GMTP900_YAKUTSK",
  /**
   * (GMT+9:00) Palau
   */
  GMTP900_PALAU = "GMTP900_PALAU",
  /**
   * (GMT+9:30) Adelaide
   */
  GMTP930_ADELAIDE = "GMTP930_ADELAIDE",
  /**
   * (GMT+9:30) Broken_Hill
   */
  GMTP930_BROKEN_HILL = "GMTP930_BROKEN_HILL",
  /**
   * (GMT+9:30) Darwin
   */
  GMTP930_DARWIN = "GMTP930_DARWIN",
  /**
   * (GMT+10:00) DumontDUrville
   */
  GMTP1000_DUMONTDURVILLE = "GMTP1000_DUMONTDURVILLE",
  /**
   * (GMT+10:00) Ust-Nera
   */
  GMTP1000_UST_NERA = "GMTP1000_UST_NERA",
  /**
   * (GMT+10:00) Vladivostok
   */
  GMTP1000_VLADIVOSTOK = "GMTP1000_VLADIVOSTOK",
  /**
   * (GMT+10:00) Brisbane
   */
  GMTP1000_BRISBANE = "GMTP1000_BRISBANE",
  /**
   * (GMT+10:00) Currie
   */
  GMTP1000_CURRIE = "GMTP1000_CURRIE",
  /**
   * (GMT+10:00) Hobart
   */
  GMTP1000_HOBART = "GMTP1000_HOBART",
  /**
   * (GMT+10:00) Lindeman
   */
  GMTP1000_LINDEMAN = "GMTP1000_LINDEMAN",
  /**
   * (GMT+10:00) Melbourne
   */
  GMTP1000_MELBOURNE = "GMTP1000_MELBOURNE",
  /**
   * (GMT+10:00) Sydney
   */
  GMTP1000_SYDNEY = "GMTP1000_SYDNEY",
  /**
   * (GMT+10:00) Chuuk
   */
  GMTP1000_CHUUK = "GMTP1000_CHUUK",
  /**
   * (GMT+10:00) Guam
   */
  GMTP1000_GUAM = "GMTP1000_GUAM",
  /**
   * (GMT+10:00) Port_Moresby
   */
  GMTP1000_PORT_MORESBY = "GMTP1000_PORT_MORESBY",
  /**
   * (GMT+10:00) Saipan
   */
  GMTP1000_SAIPAN = "GMTP1000_SAIPAN",
  /**
   * (GMT+10:00) Truk
   */
  GMTP1000_TRUK = "GMTP1000_TRUK",
  /**
   * (GMT+10:30) Lord_Howe
   */
  GMTP1030_LORD_HOWE = "GMTP1030_LORD_HOWE",
  /**
   * (GMT+11:00) Macquarie
   */
  GMTP1100_MACQUARIE = "GMTP1100_MACQUARIE",
  /**
   * (GMT+11:00) Magadan
   */
  GMTP1100_MAGADAN = "GMTP1100_MAGADAN",
  /**
   * (GMT+11:00) Sakhalin
   */
  GMTP1100_SAKHALIN = "GMTP1100_SAKHALIN",
  /**
   * (GMT+11:00) Srednekolymsk
   */
  GMTP1100_SREDNEKOLYMSK = "GMTP1100_SREDNEKOLYMSK",
  /**
   * (GMT+11:00) Bougainville
   */
  GMTP1100_BOUGAINVILLE = "GMTP1100_BOUGAINVILLE",
  /**
   * (GMT+11:00) Efate
   */
  GMTP1100_EFATE = "GMTP1100_EFATE",
  /**
   * (GMT+11:00) Guadalcanal
   */
  GMTP1100_GUADALCANAL = "GMTP1100_GUADALCANAL",
  /**
   * (GMT+11:00) Kosrae
   */
  GMTP1100_KOSRAE = "GMTP1100_KOSRAE",
  /**
   * (GMT+11:00) Norfolk
   */
  GMTP1100_NORFOLK = "GMTP1100_NORFOLK",
  /**
   * (GMT+11:00) Noumea
   */
  GMTP1100_NOUMEA = "GMTP1100_NOUMEA",
  /**
   * (GMT+11:00) Pohnpei
   */
  GMTP1100_POHNPEI = "GMTP1100_POHNPEI",
  /**
   * (GMT+11:00) Ponape
   */
  GMTP1100_PONAPE = "GMTP1100_PONAPE",
  /**
   * (GMT+12:00) McMurdo
   */
  GMTP1200_MCMURDO = "GMTP1200_MCMURDO",
  /**
   * (GMT+12:00) Anadyr
   */
  GMTP1200_ANADYR = "GMTP1200_ANADYR",
  /**
   * (GMT+12:00) Kamchatka
   */
  GMTP1200_KAMCHATKA = "GMTP1200_KAMCHATKA",
  /**
   * (GMT+12:00) Auckland
   */
  GMTP1200_AUCKLAND = "GMTP1200_AUCKLAND",
  /**
   * (GMT+12:00) Fiji
   */
  GMTP1200_FIJI = "GMTP1200_FIJI",
  /**
   * (GMT+12:00) Funafuti
   */
  GMTP1200_FUNAFUTI = "GMTP1200_FUNAFUTI",
  /**
   * (GMT+12:00) Kwajalein
   */
  GMTP1200_KWAJALEIN = "GMTP1200_KWAJALEIN",
  /**
   * (GMT+12:00) Majuro
   */
  GMTP1200_MAJURO = "GMTP1200_MAJURO",
  /**
   * (GMT+12:00) Nauru
   */
  GMTP1200_NAURU = "GMTP1200_NAURU",
  /**
   * (GMT+12:00) Tarawa
   */
  GMTP1200_TARAWA = "GMTP1200_TARAWA",
  /**
   * (GMT+12:00) Wake
   */
  GMTP1200_WAKE = "GMTP1200_WAKE",
  /**
   * (GMT+12:00) Walli
   */
  GMTP1200_WALLI = "GMTP1200_WALLI",
  /**
   * (GMT+12:45) Chatham
   */
  GMTP1245_CHATHAM = "GMTP1245_CHATHAM",
  /**
   * (GMT+13:00) Apia
   */
  GMTP1300_APIA = "GMTP1300_APIA",
  /**
   * (GMT+13:00) Enderbury
   */
  GMTP1300_ENDERBURY = "GMTP1300_ENDERBURY",
  /**
   * (GMT+13:00) Fakaofo
   */
  GMTP1300_FAKAOFO = "GMTP1300_FAKAOFO",
  /**
   * (GMT+13:00) Tongatapu
   */
  GMTP1300_TONGATAPU = "GMTP1300_TONGATAPU",
}
/**
 * Справочник таймзон
 */
export type NtpTimeZoneTypeResponseEnum = keyof typeof NtpTimeZoneType
/**
 * Справочник таймзон
 */
export type NtpTimeZoneTypeRequestEnum = Exclude<NtpTimeZoneTypeResponseEnum, "TIME_ZONE_TYPE_UNKNOWN">;

/**
 * Запрос редактирования настроек NTP
 */
export type EditNtpRequestDto = {
  /**
   * Настройки Ntp-сервера
   */
  data: NtpRequestDto
  /**
   * Маска полей обновления
   */
  updateMask?: string | null
}
/**
 * Ответ на запрос редактирования настроек NTP
 */
export type EditNtpResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: EditNtpResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type EditNtpResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type EditNtpResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения настроек NTP
 */
export type GetNtpRequestDto = {
}
/**
 * Ответ на запрос получения настроек NTP
 */
export type GetNtpResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Настройки Ntp-сервера
   */
  readonly data: NtpResponseDto
}>
/**
 * Настройки Ntp-сервера
 */
export type NtpRequestDto = {
  /**
   * Адрес Ntp-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:123, ntp.acme.io:4460
   */
  address?: string
  /**
   * Таймзона
   */
  timeZoneType?: NtpTimeZoneTypeRequestEnum | "TIME_ZONE_TYPE_UNKNOWN"
}
/**
 * Настройки Ntp-сервера
 */
export type NtpResponseDto = {
  /**
   * Адрес Ntp-сервера.
   * Сетевой адрес и порт.
   * Пример: 192.168.0.1:123, ntp.acme.io:4460
   */
  address: string
  /**
   * Таймзона
   */
  timeZoneType: NtpTimeZoneTypeResponseEnum
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос редактирования настроек NTP
   */
  "EditNtpRequest": {
    "kind": "class",
    "text": "Запрос редактирования настроек NTP",
    "fields": {
      /**
       * Настройки Ntp-сервера
       */
      "data": {
        "type": "Ntp",
        "text": "Настройки Ntp-сервера",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Маска полей обновления
       */
      "updateMask": {
        "type": "google.protobuf.FieldMask",
        "text": "Маска полей обновления",
      },
    },
  },
  /**
   * Ответ на запрос редактирования настроек NTP
   */
  "EditNtpResponse": {
    "kind": "class",
    "text": "Ответ на запрос редактирования настроек NTP",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "EditNtpResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "EditNtpResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения настроек NTP
   */
  "GetNtpRequest": {
    "kind": "class",
    "text": "Запрос получения настроек NTP",
  },
  /**
   * Ответ на запрос получения настроек NTP
   */
  "GetNtpResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения настроек NTP",
    "fields": {
      /**
       * Настройки Ntp-сервера
       */
      "data": {
        "type": "Ntp",
        "text": "Настройки Ntp-сервера",
      },
    },
  },
  /**
   * Настройки Ntp-сервера
   */
  "Ntp": {
    "kind": "class",
    "text": "Настройки Ntp-сервера",
    "fields": {
      /**
       * Адрес Ntp-сервера.
       * Сетевой адрес и порт.
       * Пример: 192.168.0.1:123, ntp.acme.io:4460
       */
      "address": {
        "type": "string",
        "text": "Адрес Ntp-сервера.\nСетевой адрес и порт.\nПример: 192.168.0.1:123, ntp.acme.io:4460",
      },
      /**
       * Таймзона
       */
      "timeZoneType": {
        "type": "Ntp.TimeZoneType",
        "text": "Таймзона",
      },
    },
  },
  /**
   * Справочник таймзон
   */
  "Ntp.TimeZoneType": {
    "kind": "enum",
    "text": "Справочник таймзон",
    "values": {
      /**
       * Значение не указано
       */
      "TIME_ZONE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * (GMT-11:00) Midway
       */
      "GMTM1100_MIDWAY": {
        "i": 1,
        "text": "(GMT-11:00) Midway",
      },
      /**
       * (GMT-11:00) Niue
       */
      "GMTM1100_NIUE": {
        "i": 2,
        "text": "(GMT-11:00) Niue",
      },
      /**
       * (GMT-10:00) Adak
       */
      "GMTM1000_ADAK": {
        "i": 3,
        "text": "(GMT-10:00) Adak",
      },
      /**
       * (GMT-10:00) Honolulu
       */
      "GMTM1000_HONOLULU": {
        "i": 4,
        "text": "(GMT-10:00) Honolulu",
      },
      /**
       * (GMT-10:00) Johnston
       */
      "GMTM1000_JOHNSTON": {
        "i": 5,
        "text": "(GMT-10:00) Johnston",
      },
      /**
       * (GMT-10:00) Rarotonga
       */
      "GMTM1000_RAROTONGA": {
        "i": 6,
        "text": "(GMT-10:00) Rarotonga",
      },
      /**
       * (GMT-10:00) Tahiti
       */
      "GMTM1000_TAHITI": {
        "i": 7,
        "text": "(GMT-10:00) Tahiti",
      },
      /**
       * (GMT-9:30) Marquesas
       */
      "GMTM930_MARQUESAS": {
        "i": 8,
        "text": "(GMT-9:30) Marquesas",
      },
      /**
       * (GMT-9:00) Anchorage
       */
      "GMTM900_ANCHORAGE": {
        "i": 9,
        "text": "(GMT-9:00) Anchorage",
      },
      /**
       * (GMT-9:00) Juneau
       */
      "GMTM900_JUNEAU": {
        "i": 10,
        "text": "(GMT-9:00) Juneau",
      },
      /**
       * (GMT-9:00) Metlakatla
       */
      "GMTM900_METLAKATLA": {
        "i": 11,
        "text": "(GMT-9:00) Metlakatla",
      },
      /**
       * (GMT-9:00) Nome
       */
      "GMTM900_NOME": {
        "i": 12,
        "text": "(GMT-9:00) Nome",
      },
      /**
       * (GMT-9:00) Sitka
       */
      "GMTM900_SITKA": {
        "i": 13,
        "text": "(GMT-9:00) Sitka",
      },
      /**
       * (GMT-9:00) Yakutat
       */
      "GMTM900_YAKUTAT": {
        "i": 14,
        "text": "(GMT-9:00) Yakutat",
      },
      /**
       * (GMT-9:00) Gambier
       */
      "GMTM900_GAMBIER": {
        "i": 15,
        "text": "(GMT-9:00) Gambier",
      },
      /**
       * (GMT-8:00) Los_Angeles
       */
      "GMTM800_LOS_ANGELES": {
        "i": 16,
        "text": "(GMT-8:00) Los_Angeles",
      },
      /**
       * (GMT-8:00) Santa_Isabel
       */
      "GMTM800_SANTA_ISABEL": {
        "i": 17,
        "text": "(GMT-8:00) Santa_Isabel",
      },
      /**
       * (GMT-8:00) Tijuana
       */
      "GMTM800_TIJUANA": {
        "i": 18,
        "text": "(GMT-8:00) Tijuana",
      },
      /**
       * (GMT-8:00) Vancouver
       */
      "GMTM800_VANCOUVER": {
        "i": 19,
        "text": "(GMT-8:00) Vancouver",
      },
      /**
       * (GMT-8:00) Pitcairn
       */
      "GMTM800_PITCAIRN": {
        "i": 20,
        "text": "(GMT-8:00) Pitcairn",
      },
      /**
       * (GMT-7:00) Boise
       */
      "GMTM700_BOISE": {
        "i": 21,
        "text": "(GMT-7:00) Boise",
      },
      /**
       * (GMT-7:00) Cambridge_Bay
       */
      "GMTM700_CAMBRIDGE_BAY": {
        "i": 22,
        "text": "(GMT-7:00) Cambridge_Bay",
      },
      /**
       * (GMT-7:00) Chihuahua
       */
      "GMTM700_CHIHUAHUA": {
        "i": 23,
        "text": "(GMT-7:00) Chihuahua",
      },
      /**
       * (GMT-7:00) Creston
       */
      "GMTM700_CRESTON": {
        "i": 24,
        "text": "(GMT-7:00) Creston",
      },
      /**
       * (GMT-7:00) Dawson
       */
      "GMTM700_DAWSON": {
        "i": 25,
        "text": "(GMT-7:00) Dawson",
      },
      /**
       * (GMT-7:00) Dawson_Creek
       */
      "GMTM700_DAWSON_CREEK": {
        "i": 26,
        "text": "(GMT-7:00) Dawson_Creek",
      },
      /**
       * (GMT-7:00) Denver
       */
      "GMTM700_DENVER": {
        "i": 27,
        "text": "(GMT-7:00) Denver",
      },
      /**
       * (GMT-7:00) Edmonton
       */
      "GMTM700_EDMONTON": {
        "i": 28,
        "text": "(GMT-7:00) Edmonton",
      },
      /**
       * (GMT-7:00) Fort_Nelson
       */
      "GMTM700_FORT_NELSON": {
        "i": 29,
        "text": "(GMT-7:00) Fort_Nelson",
      },
      /**
       * (GMT-7:00) Hermosillo
       */
      "GMTM700_HERMOSILLO": {
        "i": 30,
        "text": "(GMT-7:00) Hermosillo",
      },
      /**
       * (GMT-7:00) Inuvik
       */
      "GMTM700_INUVIK": {
        "i": 31,
        "text": "(GMT-7:00) Inuvik",
      },
      /**
       * (GMT-7:00) Mazatlan
       */
      "GMTM700_MAZATLAN": {
        "i": 32,
        "text": "(GMT-7:00) Mazatlan",
      },
      /**
       * (GMT-7:00) Ojinaga
       */
      "GMTM700_OJINAGA": {
        "i": 33,
        "text": "(GMT-7:00) Ojinaga",
      },
      /**
       * (GMT-7:00) Phoenix
       */
      "GMTM700_PHOENIX": {
        "i": 34,
        "text": "(GMT-7:00) Phoenix",
      },
      /**
       * (GMT-7:00) Shiprock
       */
      "GMTM700_SHIPROCK": {
        "i": 35,
        "text": "(GMT-7:00) Shiprock",
      },
      /**
       * (GMT-7:00) Whitehorse
       */
      "GMTM700_WHITEHORSE": {
        "i": 36,
        "text": "(GMT-7:00) Whitehorse",
      },
      /**
       * (GMT-7:00) Yellowknife<
       */
      "GMTM700_YELLOWKNIFE": {
        "i": 37,
        "text": "(GMT-7:00) Yellowknife<",
      },
      /**
       * (GMT-6:00) Bahia_Banderas
       */
      "GMTM600_BAHIA_BANDERAS": {
        "i": 38,
        "text": "(GMT-6:00) Bahia_Banderas",
      },
      /**
       * (GMT-6:00) Belize
       */
      "GMTM600_BELIZE": {
        "i": 39,
        "text": "(GMT-6:00) Belize",
      },
      /**
       * (GMT-6:00) Chicago
       */
      "GMTM600_CHICAGO": {
        "i": 40,
        "text": "(GMT-6:00) Chicago",
      },
      /**
       * (GMT-6:00) Costa_Rica
       */
      "GMTM600_COSTA_RICA": {
        "i": 41,
        "text": "(GMT-6:00) Costa_Rica",
      },
      /**
       * (GMT-6:00) El_Salvador
       */
      "GMTM600_EL_SALVADOR": {
        "i": 42,
        "text": "(GMT-6:00) El_Salvador",
      },
      /**
       * (GMT-6:00) Guatemala
       */
      "GMTM600_GUATEMALA": {
        "i": 43,
        "text": "(GMT-6:00) Guatemala",
      },
      /**
       * (GMT-6:00) Knox
       */
      "GMTM600_KNOX": {
        "i": 44,
        "text": "(GMT-6:00) Knox",
      },
      /**
       * (GMT-6:00) Tell_City
       */
      "GMTM600_TELL_CITY": {
        "i": 45,
        "text": "(GMT-6:00) Tell_City",
      },
      /**
       * (GMT-6:00) Managua
       */
      "GMTM600_MANAGUA": {
        "i": 46,
        "text": "(GMT-6:00) Managua",
      },
      /**
       * (GMT-6:00) Matamoros
       */
      "GMTM600_MATAMOROS": {
        "i": 47,
        "text": "(GMT-6:00) Matamoros",
      },
      /**
       * (GMT-6:00) Menominee
       */
      "GMTM600_MENOMINEE": {
        "i": 48,
        "text": "(GMT-6:00) Menominee",
      },
      /**
       * (GMT-6:00) Merida
       */
      "GMTM600_MERIDA": {
        "i": 49,
        "text": "(GMT-6:00) Merida",
      },
      /**
       * (GMT-6:00) Mexico_City
       */
      "GMTM600_MEXICO_CITY": {
        "i": 50,
        "text": "(GMT-6:00) Mexico_City",
      },
      /**
       * (GMT-6:00) Monterrey
       */
      "GMTM600_MONTERREY": {
        "i": 51,
        "text": "(GMT-6:00) Monterrey",
      },
      /**
       * (GMT-6:00) North_Dakota
       */
      "GMTM600_NORTH_DAKOTA": {
        "i": 52,
        "text": "(GMT-6:00) North_Dakota",
      },
      /**
       * (GMT-6:00) North_Dakota/Center
       */
      "GMTM600_NORTH_DAKOTA_CENTER": {
        "i": 53,
        "text": "(GMT-6:00) North_Dakota/Center",
      },
      /**
       * (GMT-6:00) North_Dakota/New_Salem
       */
      "GMTM600_NORTH_DAKOTA_NEW_SALEM": {
        "i": 54,
        "text": "(GMT-6:00) North_Dakota/New_Salem",
      },
      /**
       * (GMT-6:00) Rainy_River
       */
      "GMTM600_RAINY_RIVER": {
        "i": 55,
        "text": "(GMT-6:00) Rainy_River",
      },
      /**
       * (GMT-6:00) Rankin_Inlet
       */
      "GMTM600_RANKIN_INLET": {
        "i": 56,
        "text": "(GMT-6:00) Rankin_Inlet",
      },
      /**
       * (GMT-6:00) Regina
       */
      "GMTM600_REGINA": {
        "i": 57,
        "text": "(GMT-6:00) Regina",
      },
      /**
       * (GMT-6:00) Resolute
       */
      "GMTM600_RESOLUTE": {
        "i": 58,
        "text": "(GMT-6:00) Resolute",
      },
      /**
       * (GMT-6:00) Swift_Current
       */
      "GMTM600_SWIFT_CURRENT": {
        "i": 59,
        "text": "(GMT-6:00) Swift_Current",
      },
      /**
       * (GMT-6:00) Tegucigalpa
       */
      "GMTM600_TEGUCIGALPA": {
        "i": 60,
        "text": "(GMT-6:00) Tegucigalpa",
      },
      /**
       * (GMT-6:00) Winnipeg
       */
      "GMTM600_WINNIPEG": {
        "i": 61,
        "text": "(GMT-6:00) Winnipeg",
      },
      /**
       * (GMT-6:00) Easter
       */
      "GMTM600_EASTER": {
        "i": 62,
        "text": "(GMT-6:00) Easter",
      },
      /**
       * (GMT-6:00) Galapagos
       */
      "GMTM600_GALAPAGOS": {
        "i": 63,
        "text": "(GMT-6:00) Galapagos",
      },
      /**
       * (GMT-5:00) Atikokan
       */
      "GMTM500_ATIKOKAN": {
        "i": 64,
        "text": "(GMT-5:00) Atikokan",
      },
      /**
       * (GMT-5:00) Bogota
       */
      "GMTM500_BOGOTA": {
        "i": 65,
        "text": "(GMT-5:00) Bogota",
      },
      /**
       * (GMT-5:00) Cancun
       */
      "GMTM500_CANCUN": {
        "i": 66,
        "text": "(GMT-5:00) Cancun",
      },
      /**
       * (GMT-5:00) Cayman
       */
      "GMTM500_CAYMAN": {
        "i": 67,
        "text": "(GMT-5:00) Cayman",
      },
      /**
       * (GMT-5:00) Detroit
       */
      "GMTM500_DETROIT": {
        "i": 68,
        "text": "(GMT-5:00) Detroit",
      },
      /**
       * (GMT-5:00) Eirunepe
       */
      "GMTM500_EIRUNEPE": {
        "i": 69,
        "text": "(GMT-5:00) Eirunepe",
      },
      /**
       * (GMT-5:00) Grand_Turk
       */
      "GMTM500_GRAND_TURK": {
        "i": 70,
        "text": "(GMT-5:00) Grand_Turk",
      },
      /**
       * (GMT-5:00) Guayaquil
       */
      "GMTM500_GUAYAQUIL": {
        "i": 71,
        "text": "(GMT-5:00) Guayaquil",
      },
      /**
       * (GMT-5:00) Havana
       */
      "GMTM500_HAVANA": {
        "i": 72,
        "text": "(GMT-5:00) Havana",
      },
      /**
       * (GMT-5:00) Indianapolis
       */
      "GMTM500_INDIANAPOLIS": {
        "i": 73,
        "text": "(GMT-5:00) Indianapolis",
      },
      /**
       * (GMT-5:00) Marengo
       */
      "GMTM500_MARENGO": {
        "i": 74,
        "text": "(GMT-5:00) Marengo",
      },
      /**
       * (GMT-5:00) Petersburg
       */
      "GMTM500_PETERSBURG": {
        "i": 75,
        "text": "(GMT-5:00) Petersburg",
      },
      /**
       * (GMT-5:00) Vevay
       */
      "GMTM500_VEVAY": {
        "i": 76,
        "text": "(GMT-5:00) Vevay",
      },
      /**
       * (GMT-5:00) Vincennes
       */
      "GMTM500_VINCENNES": {
        "i": 77,
        "text": "(GMT-5:00) Vincennes",
      },
      /**
       * (GMT-5:00) Winamac
       */
      "GMTM500_WINAMAC": {
        "i": 78,
        "text": "(GMT-5:00) Winamac",
      },
      /**
       * (GMT-5:00) Iqaluit
       */
      "GMTM500_IQALUIT": {
        "i": 79,
        "text": "(GMT-5:00) Iqaluit",
      },
      /**
       * (GMT-5:00) Jamaica
       */
      "GMTM500_JAMAICA": {
        "i": 80,
        "text": "(GMT-5:00) Jamaica",
      },
      /**
       * (GMT-5:00) Louisville
       */
      "GMTM500_LOUISVILLE": {
        "i": 81,
        "text": "(GMT-5:00) Louisville",
      },
      /**
       * (GMT-5:00) Monticello
       */
      "GMTM500_MONTICELLO": {
        "i": 82,
        "text": "(GMT-5:00) Monticello",
      },
      /**
       * (GMT-5:00) Lima
       */
      "GMTM500_LIMA": {
        "i": 83,
        "text": "(GMT-5:00) Lima",
      },
      /**
       * (GMT-5:00) Montreal
       */
      "GMTM500_MONTREAL": {
        "i": 84,
        "text": "(GMT-5:00) Montreal",
      },
      /**
       * (GMT-5:00) Nassau
       */
      "GMTM500_NASSAU": {
        "i": 85,
        "text": "(GMT-5:00) Nassau",
      },
      /**
       * (GMT-5:00) New_York
       */
      "GMTM500_NEW_YORK": {
        "i": 86,
        "text": "(GMT-5:00) New_York",
      },
      /**
       * (GMT-5:00) Nipigon
       */
      "GMTM500_NIPIGON": {
        "i": 87,
        "text": "(GMT-5:00) Nipigon",
      },
      /**
       * (GMT-5:00) Panama
       */
      "GMTM500_PANAMA": {
        "i": 88,
        "text": "(GMT-5:00) Panama",
      },
      /**
       * (GMT-5:00) Pangnirtung
       */
      "GMTM500_PANGNIRTUNG": {
        "i": 89,
        "text": "(GMT-5:00) Pangnirtung",
      },
      /**
       * (GMT-5:00) Port-au-Prince
       */
      "GMTM500_POR_AU_PRINCE": {
        "i": 90,
        "text": "(GMT-5:00) Port-au-Prince",
      },
      /**
       * (GMT-5:00) Rio_Branco
       */
      "GMTM500_RIO_BRANCO": {
        "i": 91,
        "text": "(GMT-5:00) Rio_Branco",
      },
      /**
       * (GMT-5:00) Thunder_Bay
       */
      "GMTM500_THUNDER_BAY": {
        "i": 92,
        "text": "(GMT-5:00) Thunder_Bay",
      },
      /**
       * (GMT-5:00) Toronto
       */
      "GMTM500_TORONTO": {
        "i": 93,
        "text": "(GMT-5:00) Toronto",
      },
      /**
       * (GMT-4:00) Anguilla
       */
      "GMTM400_ANGUILLA": {
        "i": 94,
        "text": "(GMT-4:00) Anguilla",
      },
      /**
       * (GMT-4:00) Antigua
       */
      "GMTM400_ANTIGUA": {
        "i": 95,
        "text": "(GMT-4:00) Antigua",
      },
      /**
       * (GMT-4:00) Aruba
       */
      "GMTM400_ARUBA": {
        "i": 96,
        "text": "(GMT-4:00) Aruba",
      },
      /**
       * (GMT-4:00) Asuncion
       */
      "GMTM400_ASUNCION": {
        "i": 97,
        "text": "(GMT-4:00) Asuncion",
      },
      /**
       * (GMT-4:00) Barbado
       */
      "GMTM400_BARBADO": {
        "i": 98,
        "text": "(GMT-4:00) Barbado",
      },
      /**
       * (GMT-4:00) Blanc-Sablon
       */
      "GMTM400_BLANC_SABLON": {
        "i": 99,
        "text": "(GMT-4:00) Blanc-Sablon",
      },
      /**
       * (GMT-4:00) Boa_Vista
       */
      "GMTM400_BOA_VISTA": {
        "i": 100,
        "text": "(GMT-4:00) Boa_Vista",
      },
      /**
       * (GMT-4:00) Campo_Grande
       */
      "GMTM400_CAMPO_GRANDE": {
        "i": 101,
        "text": "(GMT-4:00) Campo_Grande",
      },
      /**
       * (GMT-4:00) Caraca
       */
      "GMTM400_CARACA": {
        "i": 102,
        "text": "(GMT-4:00) Caraca",
      },
      /**
       * (GMT-4:00) Cuiaba
       */
      "GMTM400_CUIABA": {
        "i": 103,
        "text": "(GMT-4:00) Cuiaba",
      },
      /**
       * (GMT-4:00) Curacao
       */
      "GMTM400_CURACAO": {
        "i": 104,
        "text": "(GMT-4:00) Curacao",
      },
      /**
       * (GMT-4:00) Dominica
       */
      "GMTM400_DOMINICA": {
        "i": 105,
        "text": "(GMT-4:00) Dominica",
      },
      /**
       * (GMT-4:00) Glace_Bay
       */
      "GMTM400_GLACE_BAY": {
        "i": 106,
        "text": "(GMT-4:00) Glace_Bay",
      },
      /**
       * (GMT-4:00) Goose_Bay
       */
      "GMTM400_GOOSE_BAY": {
        "i": 107,
        "text": "(GMT-4:00) Goose_Bay",
      },
      /**
       * (GMT-4:00) Grenada
       */
      "GMTM400_GRENADA": {
        "i": 108,
        "text": "(GMT-4:00) Grenada",
      },
      /**
       * (GMT-4:00) Guadeloupe
       */
      "GMTM400_GUADELOUPE": {
        "i": 109,
        "text": "(GMT-4:00) Guadeloupe",
      },
      /**
       * (GMT-4:00) Guyana
       */
      "GMTM400_GUYANA": {
        "i": 110,
        "text": "(GMT-4:00) Guyana",
      },
      /**
       * (GMT-4:00) Halifax
       */
      "GMTM400_HALIFAX": {
        "i": 111,
        "text": "(GMT-4:00) Halifax",
      },
      /**
       * (GMT-4:00) Kralendijk
       */
      "GMTM400_KRALENDIJK": {
        "i": 112,
        "text": "(GMT-4:00) Kralendijk",
      },
      /**
       * (GMT-4:00) La_Paz
       */
      "GMTM400_LA_PAZ": {
        "i": 113,
        "text": "(GMT-4:00) La_Paz",
      },
      /**
       * (GMT-4:00) Lower_Prince
       */
      "GMTM400_LOWER_PRINCE": {
        "i": 114,
        "text": "(GMT-4:00) Lower_Prince",
      },
      /**
       * (GMT-4:00) Manau
       */
      "GMTM400_MANAU": {
        "i": 115,
        "text": "(GMT-4:00) Manau",
      },
      /**
       * (GMT-4:00) Marigot
       */
      "GMTM400_MARIGOT": {
        "i": 116,
        "text": "(GMT-4:00) Marigot",
      },
      /**
       * (GMT-4:00) Martinique
       */
      "GMTM400_MARTINIQUE": {
        "i": 117,
        "text": "(GMT-4:00) Martinique",
      },
      /**
       * (GMT-4:00) Moncton
       */
      "GMTM400_MONCTON": {
        "i": 118,
        "text": "(GMT-4:00) Moncton",
      },
      /**
       * (GMT-4:00) Montserrat
       */
      "GMTM400_MONTSERRAT": {
        "i": 119,
        "text": "(GMT-4:00) Montserrat",
      },
      /**
       * (GMT-4:00) Port_of_Spain
       */
      "GMTM400_PORT_OF_SPAIN": {
        "i": 120,
        "text": "(GMT-4:00) Port_of_Spain",
      },
      /**
       * (GMT-4:00) Porto_Velho
       */
      "GMTM400_PORTO_VELHO": {
        "i": 121,
        "text": "(GMT-4:00) Porto_Velho",
      },
      /**
       * (GMT-4:00) Puerto_Rico
       */
      "GMTM400_PUERTO_RICO": {
        "i": 122,
        "text": "(GMT-4:00) Puerto_Rico",
      },
      /**
       * (GMT-4:00) Santiago
       */
      "GMTM400_SANTIAGO": {
        "i": 123,
        "text": "(GMT-4:00) Santiago",
      },
      /**
       * (GMT-4:00) Santo_Domingo
       */
      "GMTM400_SANTO_DOMINGO": {
        "i": 124,
        "text": "(GMT-4:00) Santo_Domingo",
      },
      /**
       * (GMT-4:00) St_Barthelemy
       */
      "GMTM400_ST_BARTHELEMY": {
        "i": 125,
        "text": "(GMT-4:00) St_Barthelemy",
      },
      /**
       * (GMT-4:00) St_Kitt
       */
      "GMTM400_ST_KITT": {
        "i": 126,
        "text": "(GMT-4:00) St_Kitt",
      },
      /**
       * (GMT-4:00) St_Lucia
       */
      "GMTM400_ST_LUCIA": {
        "i": 127,
        "text": "(GMT-4:00) St_Lucia",
      },
      /**
       * (GMT-4:00) St_Thoma
       */
      "GMTM400_ST_THOMA": {
        "i": 128,
        "text": "(GMT-4:00) St_Thoma",
      },
      /**
       * (GMT-4:00) St_Vincent
       */
      "GMTM400_ST_VINCENT": {
        "i": 129,
        "text": "(GMT-4:00) St_Vincent",
      },
      /**
       * (GMT-4:00) Thule
       */
      "GMTM400_THULE": {
        "i": 130,
        "text": "(GMT-4:00) Thule",
      },
      /**
       * (GMT-4:00) Tortola
       */
      "GMTM400_TORTOLA": {
        "i": 131,
        "text": "(GMT-4:00) Tortola",
      },
      /**
       * (GMT-4:00) Bermuda
       */
      "GMTM400_BERMUDA": {
        "i": 132,
        "text": "(GMT-4:00) Bermuda",
      },
      /**
       * (GMT-3:30) St_John
       */
      "GMTM330_ST_JOHN": {
        "i": 133,
        "text": "(GMT-3:30) St_John",
      },
      /**
       * (GMT-3:00) Araguaina
       */
      "GMTM300_ARAGUAINA": {
        "i": 134,
        "text": "(GMT-3:00) Araguaina",
      },
      /**
       * (GMT-3:00) Buenos_Aire
       */
      "GMTM300_BUENOS_AIRE": {
        "i": 135,
        "text": "(GMT-3:00) Buenos_Aire",
      },
      /**
       * (GMT-3:00) Catamarca
       */
      "GMTM300_CATAMARCA": {
        "i": 136,
        "text": "(GMT-3:00) Catamarca",
      },
      /**
       * (GMT-3:00) Cordoba
       */
      "GMTM300_CORDOBA": {
        "i": 137,
        "text": "(GMT-3:00) Cordoba",
      },
      /**
       * (GMT-3:00) Jujuy
       */
      "GMTM300_JUJUY": {
        "i": 138,
        "text": "(GMT-3:00) Jujuy",
      },
      /**
       * (GMT-3:00) La_Rioja
       */
      "GMTM300_LA_RIOJA": {
        "i": 139,
        "text": "(GMT-3:00) La_Rioja",
      },
      /**
       * (GMT-3:00) Mendoza
       */
      "GMTM300_MENDOZA": {
        "i": 140,
        "text": "(GMT-3:00) Mendoza",
      },
      /**
       * (GMT-3:00) Rio_Gallego
       */
      "GMTM300_RIO_GALLEGO": {
        "i": 141,
        "text": "(GMT-3:00) Rio_Gallego",
      },
      /**
       * (GMT-3:00) Salta
       */
      "GMTM300_SALTA": {
        "i": 142,
        "text": "(GMT-3:00) Salta",
      },
      /**
       * (GMT-3:00) San_Juan
       */
      "GMTM300_SAN_JUAN": {
        "i": 143,
        "text": "(GMT-3:00) San_Juan",
      },
      /**
       * (GMT-3:00) San_Lui
       */
      "GMTM300_SAN_LUI": {
        "i": 144,
        "text": "(GMT-3:00) San_Lui",
      },
      /**
       * (GMT-3:00) Tucuman
       */
      "GMTM300_TUCUMAN": {
        "i": 145,
        "text": "(GMT-3:00) Tucuman",
      },
      /**
       * (GMT-3:00) Ushuaia
       */
      "GMTM300_USHUAIA": {
        "i": 146,
        "text": "(GMT-3:00) Ushuaia",
      },
      /**
       * (GMT-3:00) Bahia
       */
      "GMTM300_BAHIA": {
        "i": 147,
        "text": "(GMT-3:00) Bahia",
      },
      /**
       * (GMT-3:00) Belem
       */
      "GMTM300_BELEM": {
        "i": 148,
        "text": "(GMT-3:00) Belem",
      },
      /**
       * (GMT-3:00) Cayenne
       */
      "GMTM300_CAYENNE": {
        "i": 149,
        "text": "(GMT-3:00) Cayenne",
      },
      /**
       * (GMT-3:00) Fortaleza
       */
      "GMTM300_FORTALEZA": {
        "i": 150,
        "text": "(GMT-3:00) Fortaleza",
      },
      /**
       * (GMT-3:00) Godthab
       */
      "GMTM300_GODTHAB": {
        "i": 151,
        "text": "(GMT-3:00) Godthab",
      },
      /**
       * (GMT-3:00) Maceio
       */
      "GMTM300_MACEIO": {
        "i": 152,
        "text": "(GMT-3:00) Maceio",
      },
      /**
       * (GMT-3:00) Miquelon
       */
      "GMTM300_MIQUELON": {
        "i": 153,
        "text": "(GMT-3:00) Miquelon",
      },
      /**
       * (GMT-3:00) Montevideo
       */
      "GMTM300_MONTEVIDEO": {
        "i": 154,
        "text": "(GMT-3:00) Montevideo",
      },
      /**
       * (GMT-3:00) Nuuk
       */
      "GMTM300_NUUK": {
        "i": 155,
        "text": "(GMT-3:00) Nuuk",
      },
      /**
       * (GMT-3:00) Paramaribo
       */
      "GMTM300_PARAMARIBO": {
        "i": 156,
        "text": "(GMT-3:00) Paramaribo",
      },
      /**
       * (GMT-3:00) Punta_Arena
       */
      "GMTM300_PUNTA_ARENA": {
        "i": 157,
        "text": "(GMT-3:00) Punta_Arena",
      },
      /**
       * (GMT-3:00) Recife
       */
      "GMTM300_RECIFE": {
        "i": 158,
        "text": "(GMT-3:00) Recife",
      },
      /**
       * (GMT-3:00) Santarem
       */
      "GMTM300_SANTAREM": {
        "i": 159,
        "text": "(GMT-3:00) Santarem",
      },
      /**
       * (GMT-3:00) Sao_Paulo
       */
      "GMTM300_SAO_PAULO": {
        "i": 160,
        "text": "(GMT-3:00) Sao_Paulo",
      },
      /**
       * (GMT-3:00) Palmer
       */
      "GMTM300_PALMER": {
        "i": 161,
        "text": "(GMT-3:00) Palmer",
      },
      /**
       * (GMT-3:00) Rothera
       */
      "GMTM300_ROTHERA": {
        "i": 162,
        "text": "(GMT-3:00) Rothera",
      },
      /**
       * (GMT-3:00) Stanley
       */
      "GMTM300_STANLEY": {
        "i": 163,
        "text": "(GMT-3:00) Stanley",
      },
      /**
       * (GMT-2:00) Noronha
       */
      "GMTM200_NORONHA": {
        "i": 164,
        "text": "(GMT-2:00) Noronha",
      },
      /**
       * (GMT-2:00) South_Georgia
       */
      "GMTM200_SOUTH_GEORGIA": {
        "i": 165,
        "text": "(GMT-2:00) South_Georgia",
      },
      /**
       * (GMT-1:00) Scoresbysund
       */
      "GMTM100_SCORESBYSUND": {
        "i": 166,
        "text": "(GMT-1:00) Scoresbysund",
      },
      /**
       * (GMT-1:00) Azore
       */
      "GMTM100_AZORE": {
        "i": 167,
        "text": "(GMT-1:00) Azore",
      },
      /**
       * (GMT-1:00) Cape_Verde
       */
      "GMTM100_CAPE_VERDE": {
        "i": 168,
        "text": "(GMT-1:00) Cape_Verde",
      },
      /**
       * (GMT+0:00) Abidjan
       */
      "GMTP000_ABIDJAN": {
        "i": 169,
        "text": "(GMT+0:00) Abidjan",
      },
      /**
       * (GMT+0:00) Accra
       */
      "GMTP000_ACCRA": {
        "i": 170,
        "text": "(GMT+0:00) Accra",
      },
      /**
       * (GMT+0:00) Bamako
       */
      "GMTP000_BAMAKO": {
        "i": 171,
        "text": "(GMT+0:00) Bamako",
      },
      /**
       * (GMT+0:00) Banjul
       */
      "GMTP000_BANJUL": {
        "i": 172,
        "text": "(GMT+0:00) Banjul",
      },
      /**
       * (GMT+0:00) Bissau
       */
      "GMTP000_BISSAU": {
        "i": 173,
        "text": "(GMT+0:00) Bissau",
      },
      /**
       * (GMT+0:00) Conakry
       */
      "GMTP000_CONAKRY": {
        "i": 174,
        "text": "(GMT+0:00) Conakry",
      },
      /**
       * (GMT+0:00) Dakar
       */
      "GMTP000_DAKAR": {
        "i": 175,
        "text": "(GMT+0:00) Dakar",
      },
      /**
       * (GMT+0:00) Freetown
       */
      "GMTP000_FREETOWN": {
        "i": 176,
        "text": "(GMT+0:00) Freetown",
      },
      /**
       * (GMT+0:00) Lome
       */
      "GMTP000_LOME": {
        "i": 177,
        "text": "(GMT+0:00) Lome",
      },
      /**
       * (GMT+0:00) Monrovia
       */
      "GMTP000_MONROVIA": {
        "i": 178,
        "text": "(GMT+0:00) Monrovia",
      },
      /**
       * (GMT+0:00) Nouakchott
       */
      "GMTP000_NOUAKCHOTT": {
        "i": 179,
        "text": "(GMT+0:00) Nouakchott",
      },
      /**
       * (GMT+0:00) Ouagadougou
       */
      "GMTP000_OUAGADOUGOU": {
        "i": 180,
        "text": "(GMT+0:00) Ouagadougou",
      },
      /**
       * (GMT+0:00) Sao_Tome
       */
      "GMTP000_SAO_TOME": {
        "i": 181,
        "text": "(GMT+0:00) Sao_Tome",
      },
      /**
       * (GMT+0:00) Danmarkshavn
       */
      "GMTP000_DANMARKSHAVN": {
        "i": 182,
        "text": "(GMT+0:00) Danmarkshavn",
      },
      /**
       * (GMT+0:00) Troll
       */
      "GMTP000_TROLL": {
        "i": 183,
        "text": "(GMT+0:00) Troll",
      },
      /**
       * (GMT+0:00) Canary
       */
      "GMTP000_CANARY": {
        "i": 184,
        "text": "(GMT+0:00) Canary",
      },
      /**
       * (GMT+0:00) Faroe
       */
      "GMTP000_FAROE": {
        "i": 185,
        "text": "(GMT+0:00) Faroe",
      },
      /**
       * (GMT+0:00) Madeira
       */
      "GMTP000_MADEIRA": {
        "i": 186,
        "text": "(GMT+0:00) Madeira",
      },
      /**
       * (GMT+0:00) Reykjavik
       */
      "GMTP000_REYKJAVIK": {
        "i": 187,
        "text": "(GMT+0:00) Reykjavik",
      },
      /**
       * (GMT+0:00) St_Helena
       */
      "GMTP000_ST_HELENA": {
        "i": 188,
        "text": "(GMT+0:00) St_Helena",
      },
      /**
       * (GMT+0:00) Guernsey
       */
      "GMTP000_GUERNSEY": {
        "i": 189,
        "text": "(GMT+0:00) Guernsey",
      },
      /**
       * (GMT+0:00) Isle_of_Man
       */
      "GMTP000_ISLE_OF_MAN": {
        "i": 190,
        "text": "(GMT+0:00) Isle_of_Man",
      },
      /**
       * (GMT+0:00) Jersey
       */
      "GMTP000_JERSEY": {
        "i": 191,
        "text": "(GMT+0:00) Jersey",
      },
      /**
       * (GMT+0:00) Lisbon
       */
      "GMTP000_LISBON": {
        "i": 192,
        "text": "(GMT+0:00) Lisbon",
      },
      /**
       * (GMT+0:00) London
       */
      "GMTP000_LONDON": {
        "i": 193,
        "text": "(GMT+0:00) London",
      },
      /**
       * (GMT+0:00) GMT
       */
      "GMTP000_GMT": {
        "i": 194,
        "text": "(GMT+0:00) GMT",
      },
      /**
       * (GMT+1:00) Algier
       */
      "GMTP100_ALGIER": {
        "i": 195,
        "text": "(GMT+1:00) Algier",
      },
      /**
       * (GMT+1:00) Bangui
       */
      "GMTP100_BANGUI": {
        "i": 196,
        "text": "(GMT+1:00) Bangui",
      },
      /**
       * (GMT+1:00) Brazzaville
       */
      "GMTP100_BRAZZAVILLE": {
        "i": 197,
        "text": "(GMT+1:00) Brazzaville",
      },
      /**
       * (GMT+1:00) Casablanca
       */
      "GMTP100_CASABLANCA": {
        "i": 198,
        "text": "(GMT+1:00) Casablanca",
      },
      /**
       * (GMT+1:00) Ceuta
       */
      "GMTP100_CEUTA": {
        "i": 199,
        "text": "(GMT+1:00) Ceuta",
      },
      /**
       * (GMT+1:00) Douala
       */
      "GMTP100_DOUALA": {
        "i": 200,
        "text": "(GMT+1:00) Douala",
      },
      /**
       * (GMT+1:00) El_Aaiun
       */
      "GMTP100_EL_AAIUN": {
        "i": 201,
        "text": "(GMT+1:00) El_Aaiun",
      },
      /**
       * (GMT+1:00) Kinshasa
       */
      "GMTP100_KINSHASA": {
        "i": 202,
        "text": "(GMT+1:00) Kinshasa",
      },
      /**
       * (GMT+1:00) Lago
       */
      "GMTP100_LAGO": {
        "i": 203,
        "text": "(GMT+1:00) Lago",
      },
      /**
       * (GMT+1:00) Libreville
       */
      "GMTP100_LIBREVILLE": {
        "i": 204,
        "text": "(GMT+1:00) Libreville",
      },
      /**
       * (GMT+1:00) Luanda
       */
      "GMTP100_LUANDA": {
        "i": 205,
        "text": "(GMT+1:00) Luanda",
      },
      /**
       * (GMT+1:00) Malabo
       */
      "GMTP100_MALABO": {
        "i": 206,
        "text": "(GMT+1:00) Malabo",
      },
      /**
       * (GMT+1:00) Ndjamena
       */
      "GMTP100_NDJAMENA": {
        "i": 207,
        "text": "(GMT+1:00) Ndjamena",
      },
      /**
       * (GMT+1:00) Niamey
       */
      "GMTP100_NIAMEY": {
        "i": 208,
        "text": "(GMT+1:00) Niamey",
      },
      /**
       * (GMT+1:00) Porto-Novo
       */
      "GMTP100_PORTO_NOVO": {
        "i": 209,
        "text": "(GMT+1:00) Porto-Novo",
      },
      /**
       * (GMT+1:00) Tuni
       */
      "GMTP100_TUNI": {
        "i": 210,
        "text": "(GMT+1:00) Tuni",
      },
      /**
       * (GMT+1:00) Longyearbyen
       */
      "GMTP100_LONGYEARBYEN": {
        "i": 211,
        "text": "(GMT+1:00) Longyearbyen",
      },
      /**
       * (GMT+1:00) Amsterdam
       */
      "GMTP100_AMSTERDAM": {
        "i": 212,
        "text": "(GMT+1:00) Amsterdam",
      },
      /**
       * (GMT+1:00) Andorra
       */
      "GMTP100_ANDORRA": {
        "i": 213,
        "text": "(GMT+1:00) Andorra",
      },
      /**
       * (GMT+1:00) Belgrade
       */
      "GMTP100_BELGRADE": {
        "i": 214,
        "text": "(GMT+1:00) Belgrade",
      },
      /**
       * (GMT+1:00) Berlin
       */
      "GMTP100_BERLIN": {
        "i": 215,
        "text": "(GMT+1:00) Berlin",
      },
      /**
       * (GMT+1:00) Bratislava
       */
      "GMTP100_BRATISLAVA": {
        "i": 216,
        "text": "(GMT+1:00) Bratislava",
      },
      /**
       * (GMT+1:00) Brussel
       */
      "GMTP100_BRUSSEL": {
        "i": 217,
        "text": "(GMT+1:00) Brussel",
      },
      /**
       * (GMT+1:00) Budapest
       */
      "GMTP100_BUDAPEST": {
        "i": 218,
        "text": "(GMT+1:00) Budapest",
      },
      /**
       * (GMT+1:00) Busingen
       */
      "GMTP100_BUSINGEN": {
        "i": 219,
        "text": "(GMT+1:00) Busingen",
      },
      /**
       * (GMT+1:00) Copenhagen
       */
      "GMTP100_COPENHAGEN": {
        "i": 220,
        "text": "(GMT+1:00) Copenhagen",
      },
      /**
       * (GMT+1:00) Dublin
       */
      "GMTP100_DUBLIN": {
        "i": 221,
        "text": "(GMT+1:00) Dublin",
      },
      /**
       * (GMT+1:00) Gibraltar
       */
      "GMTP100_GIBRALTAR": {
        "i": 222,
        "text": "(GMT+1:00) Gibraltar",
      },
      /**
       * (GMT+1:00) Ljubljana
       */
      "GMTP100_LJUBLJANA": {
        "i": 223,
        "text": "(GMT+1:00) Ljubljana",
      },
      /**
       * (GMT+1:00) Luxembourg
       */
      "GMTP100_LUXEMBOURG": {
        "i": 224,
        "text": "(GMT+1:00) Luxembourg",
      },
      /**
       * (GMT+1:00) Madrid
       */
      "GMTP100_MADRID": {
        "i": 225,
        "text": "(GMT+1:00) Madrid",
      },
      /**
       * (GMT+1:00) Malta
       */
      "GMTP100_MALTA": {
        "i": 226,
        "text": "(GMT+1:00) Malta",
      },
      /**
       * (GMT+1:00) Monaco
       */
      "GMTP100_MONACO": {
        "i": 227,
        "text": "(GMT+1:00) Monaco",
      },
      /**
       * (GMT+1:00) Oslo
       */
      "GMTP100_OSLO": {
        "i": 228,
        "text": "(GMT+1:00) Oslo",
      },
      /**
       * (GMT+1:00) Pari
       */
      "GMTP100_PARI": {
        "i": 229,
        "text": "(GMT+1:00) Pari",
      },
      /**
       * (GMT+1:00) Podgorica
       */
      "GMTP100_PODGORICA": {
        "i": 230,
        "text": "(GMT+1:00) Podgorica",
      },
      /**
       * (GMT+1:00) Prague
       */
      "GMTP100_PRAGUE": {
        "i": 231,
        "text": "(GMT+1:00) Prague",
      },
      /**
       * (GMT+1:00) Rome
       */
      "GMTP100_ROME": {
        "i": 232,
        "text": "(GMT+1:00) Rome",
      },
      /**
       * (GMT+1:00) San_Marino
       */
      "GMTP100_SAN_MARINO": {
        "i": 233,
        "text": "(GMT+1:00) San_Marino",
      },
      /**
       * (GMT+1:00) Sarajevo
       */
      "GMTP100_SARAJEVO": {
        "i": 234,
        "text": "(GMT+1:00) Sarajevo",
      },
      /**
       * (GMT+1:00) Skopje
       */
      "GMTP100_SKOPJE": {
        "i": 235,
        "text": "(GMT+1:00) Skopje",
      },
      /**
       * (GMT+1:00) Stockholm
       */
      "GMTP100_STOCKHOLM": {
        "i": 236,
        "text": "(GMT+1:00) Stockholm",
      },
      /**
       * (GMT+1:00) Tirane
       */
      "GMTP100_TIRANE": {
        "i": 237,
        "text": "(GMT+1:00) Tirane",
      },
      /**
       * (GMT+1:00) Vaduz
       */
      "GMTP100_VADUZ": {
        "i": 238,
        "text": "(GMT+1:00) Vaduz",
      },
      /**
       * (GMT+1:00) Vatican
       */
      "GMTP100_VATICAN": {
        "i": 239,
        "text": "(GMT+1:00) Vatican",
      },
      /**
       * (GMT+1:00) Vienna
       */
      "GMTP100_VIENNA": {
        "i": 240,
        "text": "(GMT+1:00) Vienna",
      },
      /**
       * (GMT+1:00) Warsaw
       */
      "GMTP100_WARSAW": {
        "i": 241,
        "text": "(GMT+1:00) Warsaw",
      },
      /**
       * (GMT+1:00) Zagreb
       */
      "GMTP100_ZAGREB": {
        "i": 242,
        "text": "(GMT+1:00) Zagreb",
      },
      /**
       * (GMT+1:00) Zurich
       */
      "GMTP100_ZURICH": {
        "i": 243,
        "text": "(GMT+1:00) Zurich",
      },
      /**
       * (GMT+2:00) Blantyre
       */
      "GMTP200_BLANTYRE": {
        "i": 244,
        "text": "(GMT+2:00) Blantyre",
      },
      /**
       * (GMT+2:00) Bujumbura
       */
      "GMTP200_BUJUMBURA": {
        "i": 245,
        "text": "(GMT+2:00) Bujumbura",
      },
      /**
       * (GMT+2:00) Cairo
       */
      "GMTP200_CAIRO": {
        "i": 246,
        "text": "(GMT+2:00) Cairo",
      },
      /**
       * (GMT+2:00) Gaborone
       */
      "GMTP200_GABORONE": {
        "i": 247,
        "text": "(GMT+2:00) Gaborone",
      },
      /**
       * (GMT+2:00) Harare
       */
      "GMTP200_HARARE": {
        "i": 248,
        "text": "(GMT+2:00) Harare",
      },
      /**
       * (GMT+2:00) Johannesburg
       */
      "GMTP200_JOHANNESBURG": {
        "i": 249,
        "text": "(GMT+2:00) Johannesburg",
      },
      /**
       * (GMT+2:00) Khartoum
       */
      "GMTP200_KHARTOUM": {
        "i": 250,
        "text": "(GMT+2:00) Khartoum",
      },
      /**
       * (GMT+2:00) Kigali
       */
      "GMTP200_KIGALI": {
        "i": 251,
        "text": "(GMT+2:00) Kigali",
      },
      /**
       * (GMT+2:00) Lubumbashi
       */
      "GMTP200_LUBUMBASHI": {
        "i": 252,
        "text": "(GMT+2:00) Lubumbashi",
      },
      /**
       * (GMT+2:00) Lusaka
       */
      "GMTP200_LUSAKA": {
        "i": 253,
        "text": "(GMT+2:00) Lusaka",
      },
      /**
       * (GMT+2:00) Maputo
       */
      "GMTP200_MAPUTO": {
        "i": 254,
        "text": "(GMT+2:00) Maputo",
      },
      /**
       * (GMT+2:00) Maseru
       */
      "GMTP200_MASERU": {
        "i": 255,
        "text": "(GMT+2:00) Maseru",
      },
      /**
       * (GMT+2:00) Mbabane
       */
      "GMTP200_MBABANE": {
        "i": 256,
        "text": "(GMT+2:00) Mbabane",
      },
      /**
       * (GMT+2:00) Tripoli
       */
      "GMTP200_TRIPOLI": {
        "i": 257,
        "text": "(GMT+2:00) Tripoli",
      },
      /**
       * (GMT+2:00) Windhoek
       */
      "GMTP200_WINDHOEK": {
        "i": 258,
        "text": "(GMT+2:00) Windhoek",
      },
      /**
       * (GMT+2:00) Amman
       */
      "GMTP200_AMMAN": {
        "i": 259,
        "text": "(GMT+2:00) Amman",
      },
      /**
       * (GMT+2:00) Beirut
       */
      "GMTP200_BEIRUT": {
        "i": 260,
        "text": "(GMT+2:00) Beirut",
      },
      /**
       * (GMT+2:00) Damascu
       */
      "GMTP200_DAMASCU": {
        "i": 261,
        "text": "(GMT+2:00) Damascu",
      },
      /**
       * (GMT+2:00) Famagusta
       */
      "GMTP200_FAMAGUSTA": {
        "i": 262,
        "text": "(GMT+2:00) Famagusta",
      },
      /**
       * (GMT+2:00) Gaza
       */
      "GMTP200_GAZA": {
        "i": 263,
        "text": "(GMT+2:00) Gaza",
      },
      /**
       * (GMT+2:00) Hebron
       */
      "GMTP200_HEBRON": {
        "i": 264,
        "text": "(GMT+2:00) Hebron",
      },
      /**
       * (GMT+2:00) Jerusalem
       */
      "GMTP200_JERUSALEM": {
        "i": 265,
        "text": "(GMT+2:00) Jerusalem",
      },
      /**
       * (GMT+2:00) Athen
       */
      "GMTP200_ATHEN": {
        "i": 266,
        "text": "(GMT+2:00) Athen",
      },
      /**
       * (GMT+2:00) Bucharest
       */
      "GMTP200_BUCHAREST": {
        "i": 267,
        "text": "(GMT+2:00) Bucharest",
      },
      /**
       * (GMT+2:00) Chisinau
       */
      "GMTP200_CHISINAU": {
        "i": 268,
        "text": "(GMT+2:00) Chisinau",
      },
      /**
       * (GMT+2:00) Helsinki
       */
      "GMTP200_HELSINKI": {
        "i": 269,
        "text": "(GMT+2:00) Helsinki",
      },
      /**
       * (GMT+2:00) Kaliningrad
       */
      "GMTP200_KALININGRAD": {
        "i": 270,
        "text": "(GMT+2:00) Kaliningrad",
      },
      /**
       * (GMT+2:00) Kiev
       */
      "GMTP200_KIEV": {
        "i": 271,
        "text": "(GMT+2:00) Kiev",
      },
      /**
       * (GMT+2:00) Mariehamn
       */
      "GMTP200_MARIEHAMN": {
        "i": 272,
        "text": "(GMT+2:00) Mariehamn",
      },
      /**
       * (GMT+2:00) Nicosia
       */
      "GMTP200_NICOSIA": {
        "i": 273,
        "text": "(GMT+2:00) Nicosia",
      },
      /**
       * (GMT+2:00) Riga
       */
      "GMTP200_RIGA": {
        "i": 274,
        "text": "(GMT+2:00) Riga",
      },
      /**
       * (GMT+2:00) Sofia
       */
      "GMTP200_SOFIA": {
        "i": 275,
        "text": "(GMT+2:00) Sofia",
      },
      /**
       * (GMT+2:00) Tallinn
       */
      "GMTP200_TALLINN": {
        "i": 276,
        "text": "(GMT+2:00) Tallinn",
      },
      /**
       * (GMT+2:00) Uzhgorod
       */
      "GMTP200_UZHGOROD": {
        "i": 277,
        "text": "(GMT+2:00) Uzhgorod",
      },
      /**
       * (GMT+2:00) Vilniu
       */
      "GMTP200_VILNIU": {
        "i": 278,
        "text": "(GMT+2:00) Vilniu",
      },
      /**
       * (GMT+2:00) Zaporozhye
       */
      "GMTP200_ZAPOROZHYE": {
        "i": 279,
        "text": "(GMT+2:00) Zaporozhye",
      },
      /**
       * (GMT+3:00) Addis_Ababa
       */
      "GMTP300_ADDIS_ABABA": {
        "i": 280,
        "text": "(GMT+3:00) Addis_Ababa",
      },
      /**
       * (GMT+3:00) Asmara
       */
      "GMTP300_ASMARA": {
        "i": 281,
        "text": "(GMT+3:00) Asmara",
      },
      /**
       * (GMT+3:00) Dar_es_Salaam
       */
      "GMTP300_DAR_ES_SALAAM": {
        "i": 282,
        "text": "(GMT+3:00) Dar_es_Salaam",
      },
      /**
       * (GMT+3:00) Djibouti
       */
      "GMTP300_DJIBOUTI": {
        "i": 283,
        "text": "(GMT+3:00) Djibouti",
      },
      /**
       * (GMT+3:00) Juba
       */
      "GMTP300_JUBA": {
        "i": 284,
        "text": "(GMT+3:00) Juba",
      },
      /**
       * (GMT+3:00) Kampala
       */
      "GMTP300_KAMPALA": {
        "i": 285,
        "text": "(GMT+3:00) Kampala",
      },
      /**
       * (GMT+3:00) Mogadishu
       */
      "GMTP300_MOGADISHU": {
        "i": 286,
        "text": "(GMT+3:00) Mogadishu",
      },
      /**
       * (GMT+3:00) Nairobi
       */
      "GMTP300_NAIROBI": {
        "i": 287,
        "text": "(GMT+3:00) Nairobi",
      },
      /**
       * (GMT+3:00) Syowa
       */
      "GMTP300_SYOWA": {
        "i": 288,
        "text": "(GMT+3:00) Syowa",
      },
      /**
       * (GMT+3:00) Aden
       */
      "GMTP300_ADEN": {
        "i": 289,
        "text": "(GMT+3:00) Aden",
      },
      /**
       * (GMT+3:00) Baghdad
       */
      "GMTP300_BAGHDAD": {
        "i": 290,
        "text": "(GMT+3:00) Baghdad",
      },
      /**
       * (GMT+3:00) Bahrain
       */
      "GMTP300_BAHRAIN": {
        "i": 291,
        "text": "(GMT+3:00) Bahrain",
      },
      /**
       * (GMT+3:00) Kuwait
       */
      "GMTP300_KUWAIT": {
        "i": 292,
        "text": "(GMT+3:00) Kuwait",
      },
      /**
       * (GMT+3:00) Qatar
       */
      "GMTP300_QATAR": {
        "i": 293,
        "text": "(GMT+3:00) Qatar",
      },
      /**
       * (GMT+3:00) Riyadh
       */
      "GMTP300_RIYADH": {
        "i": 294,
        "text": "(GMT+3:00) Riyadh",
      },
      /**
       * (GMT+3:00) Istanbul
       */
      "GMTP300_ISTANBUL": {
        "i": 295,
        "text": "(GMT+3:00) Istanbul",
      },
      /**
       * (GMT+3:00) Kirov
       */
      "GMTP300_KIROV": {
        "i": 296,
        "text": "(GMT+3:00) Kirov",
      },
      /**
       * (GMT+3:00) Minsk
       */
      "GMTP300_MINSK": {
        "i": 297,
        "text": "(GMT+3:00) Minsk",
      },
      /**
       * (GMT+3:00) Moscow
       */
      "GMTP300_MOSCOW": {
        "i": 298,
        "text": "(GMT+3:00) Moscow",
      },
      /**
       * (GMT+3:00) Simferopol
       */
      "GMTP300_SIMFEROPOL": {
        "i": 299,
        "text": "(GMT+3:00) Simferopol",
      },
      /**
       * (GMT+3:00) Antananarivo
       */
      "GMTP300_ANTANANARIVO": {
        "i": 300,
        "text": "(GMT+3:00) Antananarivo",
      },
      /**
       * (GMT+3:00) Comoro
       */
      "GMTP300_COMORO": {
        "i": 301,
        "text": "(GMT+3:00) Comoro",
      },
      /**
       * (GMT+3:00) Mayotte
       */
      "GMTP300_MAYOTTE": {
        "i": 302,
        "text": "(GMT+3:00) Mayotte",
      },
      /**
       * (GMT+3:30) Tehran
       */
      "GMTP330_TEHRAN": {
        "i": 303,
        "text": "(GMT+3:30) Tehran",
      },
      /**
       * (GMT+4:00) Baku
       */
      "GMTP400_BAKU": {
        "i": 304,
        "text": "(GMT+4:00) Baku",
      },
      /**
       * (GMT+4:00) Dubai
       */
      "GMTP400_DUBAI": {
        "i": 305,
        "text": "(GMT+4:00) Dubai",
      },
      /**
       * (GMT+4:00) Muscat
       */
      "GMTP400_MUSCAT": {
        "i": 306,
        "text": "(GMT+4:00) Muscat",
      },
      /**
       * (GMT+4:00) Tbilisi
       */
      "GMTP400_TBILISI": {
        "i": 307,
        "text": "(GMT+4:00) Tbilisi",
      },
      /**
       * (GMT+4:00) Yerevan
       */
      "GMTP400_YEREVAN": {
        "i": 308,
        "text": "(GMT+4:00) Yerevan",
      },
      /**
       * (GMT+4:00) Astrakhan
       */
      "GMTP400_ASTRAKHAN": {
        "i": 309,
        "text": "(GMT+4:00) Astrakhan",
      },
      /**
       * (GMT+4:00) Samara
       */
      "GMTP400_SAMARA": {
        "i": 310,
        "text": "(GMT+4:00) Samara",
      },
      /**
       * (GMT+4:00) Saratov
       */
      "GMTP400_SARATOV": {
        "i": 311,
        "text": "(GMT+4:00) Saratov",
      },
      /**
       * (GMT+4:00) Ulyanovsk
       */
      "GMTP400_ULYANOVSK": {
        "i": 312,
        "text": "(GMT+4:00) Ulyanovsk",
      },
      /**
       * (GMT+4:00) Volgograd
       */
      "GMTP400_VOLGOGRAD": {
        "i": 313,
        "text": "(GMT+4:00) Volgograd",
      },
      /**
       * (GMT+4:00) Mahe
       */
      "GMTP400_MAHE": {
        "i": 314,
        "text": "(GMT+4:00) Mahe",
      },
      /**
       * (GMT+4:00) Mauritiu
       */
      "GMTP400_MAURITIU": {
        "i": 315,
        "text": "(GMT+4:00) Mauritiu",
      },
      /**
       * (GMT+4:00) Reunion
       */
      "GMTP400_REUNION": {
        "i": 316,
        "text": "(GMT+4:00) Reunion",
      },
      /**
       * (GMT+4:30) Kabul
       */
      "GMTP430_KABUL": {
        "i": 317,
        "text": "(GMT+4:30) Kabul",
      },
      /**
       * (GMT+5:00) Mawson
       */
      "GMTP500_MAWSON": {
        "i": 318,
        "text": "(GMT+5:00) Mawson",
      },
      /**
       * (GMT+5:00) Aqtau
       */
      "GMTP500_AQTAU": {
        "i": 319,
        "text": "(GMT+5:00) Aqtau",
      },
      /**
       * (GMT+5:00) Aqtobe
       */
      "GMTP500_AQTOBE": {
        "i": 320,
        "text": "(GMT+5:00) Aqtobe",
      },
      /**
       * (GMT+5:00) Ashgabat
       */
      "GMTP500_ASHGABAT": {
        "i": 321,
        "text": "(GMT+5:00) Ashgabat",
      },
      /**
       * (GMT+5:00) Atyrau
       */
      "GMTP500_ATYRAU": {
        "i": 322,
        "text": "(GMT+5:00) Atyrau",
      },
      /**
       * (GMT+5:00) Dushanbe
       */
      "GMTP500_DUSHANBE": {
        "i": 323,
        "text": "(GMT+5:00) Dushanbe",
      },
      /**
       * (GMT+5:00) Karachi
       */
      "GMTP500_KARACHI": {
        "i": 324,
        "text": "(GMT+5:00) Karachi",
      },
      /**
       * (GMT+5:00) Oral
       */
      "GMTP500_ORAL": {
        "i": 325,
        "text": "(GMT+5:00) Oral",
      },
      /**
       * (GMT+5:00) Qyzylorda
       */
      "GMTP500_QYZYLORDA": {
        "i": 326,
        "text": "(GMT+5:00) Qyzylorda",
      },
      /**
       * (GMT+5:00) Samarkand
       */
      "GMTP500_SAMARKAND": {
        "i": 327,
        "text": "(GMT+5:00) Samarkand",
      },
      /**
       * (GMT+5:00) Tashkent
       */
      "GMTP500_TASHKENT": {
        "i": 328,
        "text": "(GMT+5:00) Tashkent",
      },
      /**
       * (GMT+5:00) Yekaterinburg
       */
      "GMTP500_YEKATERINBURG": {
        "i": 329,
        "text": "(GMT+5:00) Yekaterinburg",
      },
      /**
       * (GMT+5:00) Kerguelen
       */
      "GMTP500_KERGUELEN": {
        "i": 330,
        "text": "(GMT+5:00) Kerguelen",
      },
      /**
       * (GMT+5:00) Maldive
       */
      "GMTP500_MALDIVE": {
        "i": 331,
        "text": "(GMT+5:00) Maldive",
      },
      /**
       * (GMT+5:30) Calcutta
       */
      "GMTP530_CALCUTTA": {
        "i": 332,
        "text": "(GMT+5:30) Calcutta",
      },
      /**
       * (GMT+5:30) Colombo
       */
      "GMTP530_COLOMBO": {
        "i": 333,
        "text": "(GMT+5:30) Colombo",
      },
      /**
       * (GMT+5:30) Kolkata
       */
      "GMTP530_KOLKATA": {
        "i": 334,
        "text": "(GMT+5:30) Kolkata",
      },
      /**
       * (GMT+5:45) Kathmandu
       */
      "GMTP545_KATHMANDU": {
        "i": 335,
        "text": "(GMT+5:45) Kathmandu",
      },
      /**
       * (GMT+5:45) Katmandu
       */
      "GMTP545_KATMANDU": {
        "i": 336,
        "text": "(GMT+5:45) Katmandu",
      },
      /**
       * (GMT+6:00) Vostok
       */
      "GMTP600_VOSTOK": {
        "i": 337,
        "text": "(GMT+6:00) Vostok",
      },
      /**
       * (GMT+6:00) Almaty
       */
      "GMTP600_ALMATY": {
        "i": 338,
        "text": "(GMT+6:00) Almaty",
      },
      /**
       * (GMT+6:00) Bishkek
       */
      "GMTP600_BISHKEK": {
        "i": 339,
        "text": "(GMT+6:00) Bishkek",
      },
      /**
       * (GMT+6:00) Dhaka
       */
      "GMTP600_DHAKA": {
        "i": 340,
        "text": "(GMT+6:00) Dhaka",
      },
      /**
       * (GMT+6:00) Kashgar
       */
      "GMTP600_KASHGAR": {
        "i": 341,
        "text": "(GMT+6:00) Kashgar",
      },
      /**
       * (GMT+6:00) Omsk
       */
      "GMTP600_OMSK": {
        "i": 342,
        "text": "(GMT+6:00) Omsk",
      },
      /**
       * (GMT+6:00) Qostanay
       */
      "GMTP600_QOSTANAY": {
        "i": 343,
        "text": "(GMT+6:00) Qostanay",
      },
      /**
       * (GMT+6:00) Thimphu
       */
      "GMTP600_THIMPHU": {
        "i": 344,
        "text": "(GMT+6:00) Thimphu",
      },
      /**
       * (GMT+6:00) Urumqi
       */
      "GMTP600_URUMQI": {
        "i": 345,
        "text": "(GMT+6:00) Urumqi",
      },
      /**
       * (GMT+6:00) Chago
       */
      "GMTP600_CHAGO": {
        "i": 346,
        "text": "(GMT+6:00) Chago",
      },
      /**
       * (GMT+6:30) Rangoon
       */
      "GMTP630_RANGOON": {
        "i": 347,
        "text": "(GMT+6:30) Rangoon",
      },
      /**
       * (GMT+6:30) Yangon
       */
      "GMTP630_YANGON": {
        "i": 348,
        "text": "(GMT+6:30) Yangon",
      },
      /**
       * (GMT+6:30) Coco
       */
      "GMTP630_COCO": {
        "i": 349,
        "text": "(GMT+6:30) Coco",
      },
      /**
       * (GMT+7:00) Davi
       */
      "GMTP700_DAVI": {
        "i": 350,
        "text": "(GMT+7:00) Davi",
      },
      /**
       * (GMT+7:00) Bangkok
       */
      "GMTP700_BANGKOK": {
        "i": 351,
        "text": "(GMT+7:00) Bangkok",
      },
      /**
       * (GMT+7:00) Barnaul
       */
      "GMTP700_BARNAUL": {
        "i": 352,
        "text": "(GMT+7:00) Barnaul",
      },
      /**
       * (GMT+7:00) Ho_Chi_Minh
       */
      "GMTP700_HO_CHI_MINH": {
        "i": 353,
        "text": "(GMT+7:00) Ho_Chi_Minh",
      },
      /**
       * (GMT+7:00) Hovd
       */
      "GMTP700_HOVD": {
        "i": 354,
        "text": "(GMT+7:00) Hovd",
      },
      /**
       * (GMT+7:00) Jakarta
       */
      "GMTP700_JAKARTA": {
        "i": 355,
        "text": "(GMT+7:00) Jakarta",
      },
      /**
       * (GMT+7:00) Krasnoyarsk
       */
      "GMTP700_KRASNOYARSK": {
        "i": 356,
        "text": "(GMT+7:00) Krasnoyarsk",
      },
      /**
       * (GMT+7:00) Novokuznetsk
       */
      "GMTP700_NOVOKUZNETSK": {
        "i": 357,
        "text": "(GMT+7:00) Novokuznetsk",
      },
      /**
       * (GMT+7:00) Novosibirsk
       */
      "GMTP700_NOVOSIBIRSK": {
        "i": 358,
        "text": "(GMT+7:00) Novosibirsk",
      },
      /**
       * (GMT+7:00) Phnom_Penh
       */
      "GMTP700_PHNOM_PENH": {
        "i": 359,
        "text": "(GMT+7:00) Phnom_Penh",
      },
      /**
       * (GMT+7:00) Pontianak
       */
      "GMTP700_PONTIANAK": {
        "i": 360,
        "text": "(GMT+7:00) Pontianak",
      },
      /**
       * (GMT+7:00) Tomsk
       */
      "GMTP700_TOMSK": {
        "i": 361,
        "text": "(GMT+7:00) Tomsk",
      },
      /**
       * (GMT+7:00) Vientiane
       */
      "GMTP700_VIENTIANE": {
        "i": 362,
        "text": "(GMT+7:00) Vientiane",
      },
      /**
       * (GMT+7:00) Christma
       */
      "GMTP700_CHRISTMA": {
        "i": 363,
        "text": "(GMT+7:00) Christma",
      },
      /**
       * (GMT+8:00) Casey
       */
      "GMTP800_CASEY": {
        "i": 364,
        "text": "(GMT+8:00) Casey",
      },
      /**
       * (GMT+8:00) Brunei
       */
      "GMTP800_BRUNEI": {
        "i": 365,
        "text": "(GMT+8:00) Brunei",
      },
      /**
       * (GMT+8:00) Choibalsan
       */
      "GMTP800_CHOIBALSAN": {
        "i": 366,
        "text": "(GMT+8:00) Choibalsan",
      },
      /**
       * (GMT+8:00) Chongqing
       */
      "GMTP800_CHONGQING": {
        "i": 367,
        "text": "(GMT+8:00) Chongqing",
      },
      /**
       * (GMT+8:00) Harbin
       */
      "GMTP800_HARBIN": {
        "i": 368,
        "text": "(GMT+8:00) Harbin",
      },
      /**
       * (GMT+8:00) Hong_Kong
       */
      "GMTP800_HONG_KONG": {
        "i": 369,
        "text": "(GMT+8:00) Hong_Kong",
      },
      /**
       * (GMT+8:00) Irkutsk
       */
      "GMTP800_IRKUTSK": {
        "i": 370,
        "text": "(GMT+8:00) Irkutsk",
      },
      /**
       * (GMT+8:00) Kuala_Lumpur
       */
      "GMTP800_KUALA_LUMPUR": {
        "i": 371,
        "text": "(GMT+8:00) Kuala_Lumpur",
      },
      /**
       * (GMT+8:00) Kuching
       */
      "GMTP800_KUCHING": {
        "i": 372,
        "text": "(GMT+8:00) Kuching",
      },
      /**
       * (GMT+8:00) Macau
       */
      "GMTP800_MACAU": {
        "i": 373,
        "text": "(GMT+8:00) Macau",
      },
      /**
       * (GMT+8:00) Makassar
       */
      "GMTP800_MAKASSAR": {
        "i": 374,
        "text": "(GMT+8:00) Makassar",
      },
      /**
       * (GMT+8:00) Manila
       */
      "GMTP800_MANILA": {
        "i": 375,
        "text": "(GMT+8:00) Manila",
      },
      /**
       * (GMT+8:00) Shanghai
       */
      "GMTP800_SHANGHAI": {
        "i": 376,
        "text": "(GMT+8:00) Shanghai",
      },
      /**
       * (GMT+8:00) Singapore
       */
      "GMTP800_SINGAPORE": {
        "i": 377,
        "text": "(GMT+8:00) Singapore",
      },
      /**
       * (GMT+8:00) Taipei
       */
      "GMTP800_TAIPEI": {
        "i": 378,
        "text": "(GMT+8:00) Taipei",
      },
      /**
       * (GMT+8:00) Ulaanbaatar
       */
      "GMTP800_ULAANBAATAR": {
        "i": 379,
        "text": "(GMT+8:00) Ulaanbaatar",
      },
      /**
       * (GMT+8:00) Perth
       */
      "GMTP800_PERTH": {
        "i": 380,
        "text": "(GMT+8:00) Perth",
      },
      /**
       * (GMT+8:45) Eucla
       */
      "GMTP845_EUCLA": {
        "i": 381,
        "text": "(GMT+8:45) Eucla",
      },
      /**
       * (GMT+9:00) Chita
       */
      "GMTP900_CHITA": {
        "i": 382,
        "text": "(GMT+9:00) Chita",
      },
      /**
       * (GMT+9:00) Dili
       */
      "GMTP900_DILI": {
        "i": 383,
        "text": "(GMT+9:00) Dili",
      },
      /**
       * (GMT+9:00) Jayapura
       */
      "GMTP900_JAYAPURA": {
        "i": 384,
        "text": "(GMT+9:00) Jayapura",
      },
      /**
       * (GMT+9:00) Khandyga
       */
      "GMTP900_KHANDYGA": {
        "i": 385,
        "text": "(GMT+9:00) Khandyga",
      },
      /**
       * (GMT+9:00) Pyongyang
       */
      "GMTP900_PYONGYANG": {
        "i": 386,
        "text": "(GMT+9:00) Pyongyang",
      },
      /**
       * (GMT+9:00) Seoul
       */
      "GMTP900_SEOUL": {
        "i": 387,
        "text": "(GMT+9:00) Seoul",
      },
      /**
       * (GMT+9:00) Tokyo
       */
      "GMTP900_TOKYO": {
        "i": 388,
        "text": "(GMT+9:00) Tokyo",
      },
      /**
       * (GMT+9:00) Yakutsk
       */
      "GMTP900_YAKUTSK": {
        "i": 389,
        "text": "(GMT+9:00) Yakutsk",
      },
      /**
       * (GMT+9:00) Palau
       */
      "GMTP900_PALAU": {
        "i": 390,
        "text": "(GMT+9:00) Palau",
      },
      /**
       * (GMT+9:30) Adelaide
       */
      "GMTP930_ADELAIDE": {
        "i": 391,
        "text": "(GMT+9:30) Adelaide",
      },
      /**
       * (GMT+9:30) Broken_Hill
       */
      "GMTP930_BROKEN_HILL": {
        "i": 392,
        "text": "(GMT+9:30) Broken_Hill",
      },
      /**
       * (GMT+9:30) Darwin
       */
      "GMTP930_DARWIN": {
        "i": 393,
        "text": "(GMT+9:30) Darwin",
      },
      /**
       * (GMT+10:00) DumontDUrville
       */
      "GMTP1000_DUMONTDURVILLE": {
        "i": 394,
        "text": "(GMT+10:00) DumontDUrville",
      },
      /**
       * (GMT+10:00) Ust-Nera
       */
      "GMTP1000_UST_NERA": {
        "i": 395,
        "text": "(GMT+10:00) Ust-Nera",
      },
      /**
       * (GMT+10:00) Vladivostok
       */
      "GMTP1000_VLADIVOSTOK": {
        "i": 396,
        "text": "(GMT+10:00) Vladivostok",
      },
      /**
       * (GMT+10:00) Brisbane
       */
      "GMTP1000_BRISBANE": {
        "i": 397,
        "text": "(GMT+10:00) Brisbane",
      },
      /**
       * (GMT+10:00) Currie
       */
      "GMTP1000_CURRIE": {
        "i": 398,
        "text": "(GMT+10:00) Currie",
      },
      /**
       * (GMT+10:00) Hobart
       */
      "GMTP1000_HOBART": {
        "i": 399,
        "text": "(GMT+10:00) Hobart",
      },
      /**
       * (GMT+10:00) Lindeman
       */
      "GMTP1000_LINDEMAN": {
        "i": 400,
        "text": "(GMT+10:00) Lindeman",
      },
      /**
       * (GMT+10:00) Melbourne
       */
      "GMTP1000_MELBOURNE": {
        "i": 401,
        "text": "(GMT+10:00) Melbourne",
      },
      /**
       * (GMT+10:00) Sydney
       */
      "GMTP1000_SYDNEY": {
        "i": 402,
        "text": "(GMT+10:00) Sydney",
      },
      /**
       * (GMT+10:00) Chuuk
       */
      "GMTP1000_CHUUK": {
        "i": 403,
        "text": "(GMT+10:00) Chuuk",
      },
      /**
       * (GMT+10:00) Guam
       */
      "GMTP1000_GUAM": {
        "i": 404,
        "text": "(GMT+10:00) Guam",
      },
      /**
       * (GMT+10:00) Port_Moresby
       */
      "GMTP1000_PORT_MORESBY": {
        "i": 405,
        "text": "(GMT+10:00) Port_Moresby",
      },
      /**
       * (GMT+10:00) Saipan
       */
      "GMTP1000_SAIPAN": {
        "i": 406,
        "text": "(GMT+10:00) Saipan",
      },
      /**
       * (GMT+10:00) Truk
       */
      "GMTP1000_TRUK": {
        "i": 407,
        "text": "(GMT+10:00) Truk",
      },
      /**
       * (GMT+10:30) Lord_Howe
       */
      "GMTP1030_LORD_HOWE": {
        "i": 408,
        "text": "(GMT+10:30) Lord_Howe",
      },
      /**
       * (GMT+11:00) Macquarie
       */
      "GMTP1100_MACQUARIE": {
        "i": 409,
        "text": "(GMT+11:00) Macquarie",
      },
      /**
       * (GMT+11:00) Magadan
       */
      "GMTP1100_MAGADAN": {
        "i": 410,
        "text": "(GMT+11:00) Magadan",
      },
      /**
       * (GMT+11:00) Sakhalin
       */
      "GMTP1100_SAKHALIN": {
        "i": 411,
        "text": "(GMT+11:00) Sakhalin",
      },
      /**
       * (GMT+11:00) Srednekolymsk
       */
      "GMTP1100_SREDNEKOLYMSK": {
        "i": 412,
        "text": "(GMT+11:00) Srednekolymsk",
      },
      /**
       * (GMT+11:00) Bougainville
       */
      "GMTP1100_BOUGAINVILLE": {
        "i": 413,
        "text": "(GMT+11:00) Bougainville",
      },
      /**
       * (GMT+11:00) Efate
       */
      "GMTP1100_EFATE": {
        "i": 414,
        "text": "(GMT+11:00) Efate",
      },
      /**
       * (GMT+11:00) Guadalcanal
       */
      "GMTP1100_GUADALCANAL": {
        "i": 415,
        "text": "(GMT+11:00) Guadalcanal",
      },
      /**
       * (GMT+11:00) Kosrae
       */
      "GMTP1100_KOSRAE": {
        "i": 416,
        "text": "(GMT+11:00) Kosrae",
      },
      /**
       * (GMT+11:00) Norfolk
       */
      "GMTP1100_NORFOLK": {
        "i": 417,
        "text": "(GMT+11:00) Norfolk",
      },
      /**
       * (GMT+11:00) Noumea
       */
      "GMTP1100_NOUMEA": {
        "i": 418,
        "text": "(GMT+11:00) Noumea",
      },
      /**
       * (GMT+11:00) Pohnpei
       */
      "GMTP1100_POHNPEI": {
        "i": 419,
        "text": "(GMT+11:00) Pohnpei",
      },
      /**
       * (GMT+11:00) Ponape
       */
      "GMTP1100_PONAPE": {
        "i": 420,
        "text": "(GMT+11:00) Ponape",
      },
      /**
       * (GMT+12:00) McMurdo
       */
      "GMTP1200_MCMURDO": {
        "i": 421,
        "text": "(GMT+12:00) McMurdo",
      },
      /**
       * (GMT+12:00) Anadyr
       */
      "GMTP1200_ANADYR": {
        "i": 422,
        "text": "(GMT+12:00) Anadyr",
      },
      /**
       * (GMT+12:00) Kamchatka
       */
      "GMTP1200_KAMCHATKA": {
        "i": 423,
        "text": "(GMT+12:00) Kamchatka",
      },
      /**
       * (GMT+12:00) Auckland
       */
      "GMTP1200_AUCKLAND": {
        "i": 424,
        "text": "(GMT+12:00) Auckland",
      },
      /**
       * (GMT+12:00) Fiji
       */
      "GMTP1200_FIJI": {
        "i": 425,
        "text": "(GMT+12:00) Fiji",
      },
      /**
       * (GMT+12:00) Funafuti
       */
      "GMTP1200_FUNAFUTI": {
        "i": 426,
        "text": "(GMT+12:00) Funafuti",
      },
      /**
       * (GMT+12:00) Kwajalein
       */
      "GMTP1200_KWAJALEIN": {
        "i": 427,
        "text": "(GMT+12:00) Kwajalein",
      },
      /**
       * (GMT+12:00) Majuro
       */
      "GMTP1200_MAJURO": {
        "i": 428,
        "text": "(GMT+12:00) Majuro",
      },
      /**
       * (GMT+12:00) Nauru
       */
      "GMTP1200_NAURU": {
        "i": 429,
        "text": "(GMT+12:00) Nauru",
      },
      /**
       * (GMT+12:00) Tarawa
       */
      "GMTP1200_TARAWA": {
        "i": 430,
        "text": "(GMT+12:00) Tarawa",
      },
      /**
       * (GMT+12:00) Wake
       */
      "GMTP1200_WAKE": {
        "i": 431,
        "text": "(GMT+12:00) Wake",
      },
      /**
       * (GMT+12:00) Walli
       */
      "GMTP1200_WALLI": {
        "i": 432,
        "text": "(GMT+12:00) Walli",
      },
      /**
       * (GMT+12:45) Chatham
       */
      "GMTP1245_CHATHAM": {
        "i": 433,
        "text": "(GMT+12:45) Chatham",
      },
      /**
       * (GMT+13:00) Apia
       */
      "GMTP1300_APIA": {
        "i": 434,
        "text": "(GMT+13:00) Apia",
      },
      /**
       * (GMT+13:00) Enderbury
       */
      "GMTP1300_ENDERBURY": {
        "i": 435,
        "text": "(GMT+13:00) Enderbury",
      },
      /**
       * (GMT+13:00) Fakaofo
       */
      "GMTP1300_FAKAOFO": {
        "i": 436,
        "text": "(GMT+13:00) Fakaofo",
      },
      /**
       * (GMT+13:00) Tongatapu
       */
      "GMTP1300_TONGATAPU": {
        "i": 437,
        "text": "(GMT+13:00) Tongatapu",
      },
    },
  },
}